import { observer } from 'mobx-react-lite';
import { Button, Form, Modal } from 'semantic-ui-react';
import {
  Dispatch,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useStore } from '../../../app/stores/store';
import './activitytogglemile.css';
import { FileUploadInterface } from '../../../app/models/Profile';
import jsPDF from 'jspdf';
import { v4 as uuid } from 'uuid';
import agent from '../../../app/api/agent';
import { workflowMetadata } from '../../../app/models/workflowMetaData';
import AlertsResolveorRejectModal from '../../../app/common/modals/AlertsResolveorRejectModal';
import MediaAssetResolveModal from '../../../app/common/modals/MediaAssetResolveModal';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import { updateHistoryMain } from '../../../app/models/history';
import { WorkflowOptions } from '../../../app/models/template';
import { isArray } from 'lodash';
import Components from '../../../app/common/components';
import { toast } from 'react-toastify';
import { FileType } from './FileUpload';
import CamModal, { PhotoType } from './CamModal';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { columnType } from '../../../app/common/components/DynamicRowsComponent';
import { GetCurrentUser } from '../../../app/models/user';
import { assignUserType, uploadFileType } from '../../../app/api/types';
import NFAIReelAnalysisReport from '../NFAI_Report/ReelAnalysis';
import NFAIRestorationReport from '../NFAI_Report/RestorationReport';
import { pdf, PDFDownloadLink } from '@react-pdf/renderer';
import ColorGradingReport from '../NFAI_Report/ColorGrading';
import GradingQC from '../NFAI_Report/GradingQC';
import AudioSyncReport from '../NFAI_Report/Audio_Sync_Report/index';
import DM_And_BaseGrading_Reports from '../NFAI_Report/DM_And_BaseGrading_Reports';
import { BaseGrade_DM_metadata, DmFramesReel } from '../NFAI_Report/DM_And_Basegrading-constant';
import CutlistPreviewModal from '../NFAI_Report/CutlistPreviewModal';
import { AVSyncValidation } from '../NFAI_Report/Audio_Sync_Report/type';
import { Reel_AnaylsisValidation, Restoration_Validation } from '../NFAI_Report/constant';
import { colorGradingvalidation } from '../NFAI_Report/color-grading-constants';
import { getNextTaskOrSubTaskId } from '../../../app/stores/NFAI_Restoration_Smartflow/types';
import DeliverablesReport from '../NFAI_Report/Master Reports/DeliverablesReport';
import LTOReport from '../NFAI_Report/Master Reports/LTOReport';
import FFV1ReportsPDF from '../NFAI_Report/Master Reports/FFV1ReportsPDF';
import DCPEncryptedOpenReport from '../NFAI_Report/Master Reports/DCPEncryptedOpenReport';
import moment from 'moment';
import LTOLabelGeneration from '../NFAI_Report/Master Reports/LTOLabelGeneration';
import ConsolidatedReport from '../NFAI_Report/Master Reports/ConsolidatedReport';
import { getFirstSubtaskIdByName } from '../NFAI_Report/Master Reports/service/types';
import {
  normalizeDeliverablesQcElementValue,
  normalizeDeliverablesQcRows,
} from './deliverablesQcUtils';

interface Props {
  eleModalTitle: string;
  subTaskIdNo: string;
  assignedUsers?: assignUserType[];
  showTasksModal: boolean;
  closeTaskFormModal: any;
  taskname: string;
  selectedSubTask: workflowMetadata[] | any;
  taskData: any;
  taskId: any;
  currSubTaskData: any;
  hideSubtask: any;
  withoutModal?: boolean;
  actionerNameHandler: (value: string) => void;
  workflowHistoryHandler: (
    result: {
      id: string;
      description: string;
      values: string;
      type: string;
    }[],
    removedRow: any[],
    addedRow: any[],
    // alteredRowHistory: any,
    initialElementValue: any,
    headers: columnType[],
  ) => void;
  sendCurrentWorkflowData?: (data: string, status: any) => void;
  reportWorflowUpdate?: any;
  name?: string;
  completeAPIHandler?: () => void;
  SmartTrackerReports?: boolean;
  smartTrackButtonLabel?: string;
  setSmartTrackButtonLabel?: Dispatch<SetStateAction<string>>;
  nfaiToast?: string;
}

function TaskFormModal({
  taskname,
  selectedSubTask,
  eleModalTitle,
  showTasksModal,
  closeTaskFormModal,
  subTaskIdNo,
  taskData,
  taskId,
  currSubTaskData,
  hideSubtask,
  withoutModal,
  actionerNameHandler,
  workflowHistoryHandler,
  reportWorflowUpdate,
  // name,
  SmartTrackerReports,
  smartTrackButtonLabel,
  setSmartTrackButtonLabel,
  nfaiToast = '',
}: // completeAPIHandler,
Props) {
  let {
    mediaAssetStore,
    metaDataStore: { ColorGradingParameters, DeliverablesParameters, LTOBarCodeValues },
    metaDataStore,
    WorkLevelStore,
    ElementStore: {
      getResolvedId,
      kanbanTiggerbutton,
      triggerResolve,
      postAPITemp,
      generatePdf,
      getTotalCountsOfTask,
      uploadFilesSubTask,
      postCommunicationTemp,
      workflowSubTask,
      HandleWorkflowSubtaskApi,
      workflowSubTaskLoader
    },
    activityStore,
    userStore: { user },
    dashboardStore,
    commonStore,
    KanbanStore,
    ApiStore,
    TrackingReportStore: {
      CurrentSubtaskStatus,
      currWorkflowModel,
      statusButtonShow,
    },
    viewStore,
    viewStore: {
      activeOrder,
      metadata,
      workFlowProcessChangesUpdate,
      NFAIworkFlowProcessChangesUpdate,
      getItemPageFilesStructure,
      getActiveOrder,
      NFAIApisettings,
      // HandleCutlistReelAnaylsis,
      // itemDetails
    },
    emailStore: { triggerRejectNotification, },
    reportStore,
    masteringStore: { conslidatedApiCall },
    masteringStore
  } = useStore();

  const [currStatus, setCurrStatus] = useState<number>(0);
  const [localElementData, setLocalDataElement] = useState<any>([]);

  const [copySortedElementData, setCopySortedElementData] = useState<any>([]);
  const { selectedActivity: activity } = activityStore;
  const [camImage, setCamImage] = useState<FileUploadInterface[]>([]);
  const [mastersList, setMasterList] = useState<any>({});
  const [userList, setUserList] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<any>({});

  const [hasElements, setHasElements] = useState<boolean>(false);
  const mandatoryFieldsRef = useRef<any>({});

  const [actionerName, setActionerName] = useState('');
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isRejectModalOpened, setIsRejectModalOpened] = useState(false);
  const [isResolveModalOpened, setIsResolveModalOpened] = useState(false);
  const [temporaryFilePath, setTemporaryFilePath] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [removedRow, setRemovedRow] = useState<any>();
  const [addedRow, setAddedRow] = useState<any>();
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  // const [alteredRowHistory, setAlteredRowHistory] = useState<any[]>([]);

  const [dataGridHeaders, setDataGridHeaders] = useState<any[]>([]);
  const [dataGridInitialValue, setDataGridInitialValue] = useState<any[]>([]);
  const [cancelModelAPI, setCancelModelAPI] = useState({
    isFormCompleted: false,
    isTrackerCompleted: false,
    isDynamicMetadataCompleted: false,
    isLoading: false,
  });
  const [apiSettings, setApiSettings] = useState<any[]>([]);
  const [workFlowCommunication, setWorkFlowCommunication] = useState<any[]>([]);
  const [nFAIReportLoader, setNFAIReportLoader] = useState(false);
  const [elementLength,setElementLength] = useState<number>(0);
  const [viewShotsModel, setViewShotsModel] = useState<boolean>(false);
  const [isNFAITableCheck, setIsNFAITableCheck] = useState<string>('');
// useEffect(() => {
//   if(localElementData.length > 0){
//    setPdfRerender(pdfRerender+1);
//   }
// },[localElementData]);


useEffect(() => {
  if(localElementData.length > 0 && commonStore.NFAIReportCustomer && ['NFHM Color Grading QC','Data Management','NFHM Color Grading QC'].includes(selectedSubTask.subTaskName)){
    let condtionArr = '';
    const filtereddyntable = localElementData.filter((e:any) => e.elementType === 'DynamicTable');
    if (filtereddyntable.length > 0) {
        outerLoop: // Label for the outer loop
        for (let i = 0; i < filtereddyntable.length; i++) {
            const element = filtereddyntable[i];
            const stringData = element?.elementValue?.split('|')[1]?.replace(/\t/g, ' ') || '[]';
            const parsedValue = JSON.parse(stringData || '[]');
            for (let j = 0; j < parsedValue.length; j++) {   
                const obj = parsedValue[j];
                if (Object.values(obj).includes('No') && selectedSubTask.subTaskName === 'Data Management') {
                  condtionArr = "Please review and update the table. One or more columns have the 'No' dropdown value selected.";                  
                }
                if (Object.values(obj).includes('Not Approved') &&  'NFHM Color Grading QC' === selectedSubTask.subTaskName) {
                    condtionArr = 'Please review and update the table. One or more columns are not approved.';
                    break outerLoop; // Break out of both loops
                }
                if (Object.values(obj).includes('Fail') && selectedSubTask.subTaskName === 'NFHM Color Grading QC') {
                    condtionArr = "Please review and update the table. One or more columns have the 'Fail' dropdown value selected.";
                    break outerLoop; // Break out of both loops
                }
            }
        }
    }
    setIsNFAITableCheck(condtionArr);
  }
  // eslint-disable-next-line
},[localElementData])
  useEffect(() => {
    if (
      cancelModelAPI.isDynamicMetadataCompleted &&
      cancelModelAPI.isFormCompleted &&
      (cancelModelAPI.isTrackerCompleted || SmartTrackerReports)
    ) {
      closeTaskFormModal(true);
      setCancelModelAPI({
        isFormCompleted: false,
        isTrackerCompleted: false,
        isDynamicMetadataCompleted: false,
        isLoading: false,
      });
    }

    // eslint-disable-next-line
  }, [cancelModelAPI]);

  useEffect(() => {
    if (CurrentSubtaskStatus.status === 'Resolve') {
      openResolve();
    }
    // eslint-disable-next-line
  }, [CurrentSubtaskStatus.status]);

  useEffect(() => {
    if(SmartTrackerReports) return;
    WorkLevelStore.loadWorkLevelBasedOnItemLevel(activity?.id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const ltoLabel = selectedSubTask.subTaskName === 'LTO Label Creation';
    if (ltoLabel){
      LTOBarCodeValues(activity?.id)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if(localElementData.length === elementLength && localElementData.length !== 0){
      setHasElements(true); 
       setIsLoading(false);
    }
    else{
      setHasElements(false);
    }
      // eslint-disable-next-line
  }, [localElementData, currWorkflowModel]);
  useEffect(() => {
    setCamImage(dashboardStore.dashboard.camImageUrl);
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.camImageUrl]);

  useEffect(() => {
    let errorMessageLocal = Object.assign({}, errorMessage);

    localElementData?.forEach((metadata: any) => {
      let {
        readOnly,
        enableByDefault,
        elementType,
        elementValue,
        elementId,
        validation,
        isMandatory,
        files,
        photos,
      } = metadata || {};
      if (readOnly || !enableByDefault) return;

      let result = '';
      if (/textbox/gi.test(elementType) && elementValue) {
        result = commonStore.genericValidation(
          elementValue || '',
          validation || '',
        );
      }

      if (result?.length) {
        errorMessageLocal[`${elementId}`] = result;
      } else if (elementType === 'DynamicTable' && isMandatory) {
        const stringData = elementValue?.split('DynamicTable|')?.[1];
        let tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
        if (tempValue.length === 0) {
          errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
        } else {
          let columnHeaders: string[] = [];
          if (tempValue[0]) {
            columnHeaders = Object.keys(tempValue[0]);
            columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
          }
          let count = 0;
          columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
          tempValue?.forEach((tableRowData: any) => {
            columnHeaders?.forEach((header: string) => {
              if (tableRowData[header] === '') {
                count++;
              }
            });
          });
          if (count) {
            errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
          } else {
            delete errorMessageLocal[`${elementId}`];
          }
        }
      } else if (
        (elementType === 'AddFiles' && isMandatory && files.length === 0) ||
        (elementType === 'AddPhotograph' && isMandatory && photos.length === 0)
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        elementValue?.length === 0 &&
        elementType !== 'AddFiles' &&
        elementType !== 'AddPhotograph'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        !elementValue?.split('|')?.[1] &&
        elementType === 'Masters'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else {
        delete errorMessageLocal[`${elementId}`];
      }

      /**
       * Mandatory
       */
      if (
        (elementType === 'AddFiles' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          files.length === 0) ||
        (elementType === 'AddPhotograph' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          photos.length === 0)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        elementType !== 'AddPhotograph' &&
        elementType !== 'AddFiles' &&
        elementValue?.length === 0 &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        (elementType === 'Users' || elementType === 'Masters') &&
        elementValue?.split('|')?.[1] === undefined &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else {
        delete mandatoryFieldsRef.current[`${elementId}`];
      }

      setErrorMessage(errorMessageLocal);
    });
    // eslint-disable-next-line
  }, [localElementData, currWorkflowModel]);

  useEffect( () => {
    const handleDetails = async ()=>{
      let data;
      if (selectedSubTask?.subTaskId !== undefined) {
        data = selectedSubTask?.subTaskId;
      } else {
        data = selectedSubTask?.[0]?.subTaskId;
      }
      HandleWorkflowSubtaskApi(data)
    }
    handleDetails();
    // eslint-disable-next-line
  }, [selectedSubTask?.subTaskId]);

  
  useEffect( () => {
    if(workflowSubTask?.subTaskId === '') return;
    fetchData();
    // eslint-disable-next-line
  }, [workflowSubTask]) ;


  useEffect(() => {
    setCurrStatus(selectedSubTask?.subTaskstatus);
    // eslint-disable-next-line
  }, [selectedSubTask?.subTaskstatus]);

  /** ------------ set the local state -------------- */
  const configureLocalElement = async (sortedElementData: any[]) => {
    if (sortedElementData?.length === 0) return;
    let filterDynamicMetadata = sortedElementData?.filter(
      (data: { elementType: string; enableByDefault: boolean }) =>
        data.elementType === 'Dynamicmetadata' ||
        data.elementType === 'ParentDynamicmetadata',
    );
    let exceptDynamic = sortedElementData?.flatMap(
      (data: { elementType: string; enableByDefault: boolean }) => {
        if (
          data.elementType === 'ParentDynamicmetadata' ||
          data.elementType === 'Dynamicmetadata'
          // !data.enableByDefault
        ) {
          return [];
        } else {
          return data;
        }
      },
    );
    let list: any = [];
    getActiveOrder({ itemId: activity?.id })
      .then(async (Response) => {
        if (Response) {
          for (let i = 0; i < filterDynamicMetadata?.length; i++) {
            let params = {
              itemId: activity?.id,
              templateId: activeOrder.templateId || Response || '',
              templateElementId:
                filterDynamicMetadata[i]?.elementValue?.split('|')?.[1] || '',
            };
            let result = await agent.ElementTypes.elementDetails(params);
            let data: any = result?.data;
            // if (data.elementName === 'DM Report') {
            //   let elementValue1 = data.elementValue?.includes('DynamicTable|')
            //     ? JSON.parse(
            //         data.elementValue
            //           .split('DynamicTable|')[1]
            //           ?.replace(/\n/g, ''),
            //       )
            //     : JSON.parse(data?.elementValue);
            //   const changedValue = elementValue1.map((e: any) => ({
            //     ...e,
            //     'Start Frame': '',
            //     'End Frame': '',
            //     'Yes/No': '',
            //   }));
            //   data.elementValue = `DynamicTable|${JSON.stringify(changedValue)}`;
            // }
            if (data) {
              let payload = {
                ...data,
                readOnly: !!filterDynamicMetadata[i]?.readOnly,
                isMandatory: !!filterDynamicMetadata[i]?.isMandatory,
                enableByDefault: !!filterDynamicMetadata[i]?.enableByDefault,
                isDynamic: true,
              };
              list.push(payload);
            }
          }
        }
      })
      .then(async () => {
        let combine = [...list, ...exceptDynamic];
        if (combine && JSON.parse(JSON.stringify(combine))) {
          let copy = JSON.parse(JSON.stringify(combine));
          setCopySortedElementData(copy);
          let usersHashmap: any = {};
          const usersListOptions = async (userId: string) => {
            let result: any = await agent.WorkLevels.usersListAPI(userId);
            let returnData = await (result || [])?.map((data: string) => {
              return {
                key: data,
                value: data,
                text: data,
              };
            });
            return returnData;
          };
          let filterUsers = combine?.filter(
            (data: { elementType: string }) => data.elementType === 'Users',
          );
          filterUsers?.forEach(async (data: { elementValue: string }) => {
            let result = await usersListOptions(data.elementValue?.split('|')?.[0]);
            usersHashmap[`${data.elementValue?.split('|')?.[0]}`] = result;
            setUserList(usersHashmap);
          });
          if(user?.customerName === 'NFAIReport' && currStatus !== 0){
            const AVSyncRemarksIndex = combine.findIndex(
              (element: any) =>
                element.elementName === 'NFAI AVSyn Remarks',
            );
            const updatedElementData: any = [...combine]; 
            if(AVSyncRemarksIndex !== -1 && updatedElementData[AVSyncRemarksIndex].elementValue !== 'DynamicTable|[]' && !activity?.title.includes('Reels') && !activity?.title?.includes('Cutlist')){
           const response = await reportStore.AVSyncfromParrentHandler(activity?.id)
             const renamedValues = response?.map((item:any) => ({
              "Reel No": item.reel_No,
              "Frame Count": item.frame_Count,
              "Start Time Code": item.start_Time_Code,
              "End Time Code": item.end_Time_Code,
              "Audio Scan QC Report": item.audio_Scan_QC_Report,
              "Audio Scan Report": item.audio_Scan_Report,
              "NFI Digitization QC Report": item.nfI_Digitization_QC_Report,
              "Source Remarks": item.source_Remarks
            }));
            
            // Now 'renamedValues' contains an array of objects with the desired key names
            
             const jsonValue = JSON.stringify(renamedValues)
             updatedElementData[AVSyncRemarksIndex].elementValue =
              `DynamicTable|${jsonValue}`;
              combine = updatedElementData;
            }
            const colorGradingIndex = combine.findIndex(
              (element: any) =>
                element.elementName === 'Colour Grading',
            );
            if(colorGradingIndex !== -1 && updatedElementData[colorGradingIndex].elementValue === ''){
             await ColorGradingParameters(activity?.title.split('-')[1].trim() || '').then((Response) => {
               const updatedData = Response.map((item: any) => ({
                 _uuid_: item._uuid_,
                 Check_Parameters: item.check_Parameters,
                 Technical_Description: item.technical_Description,
                 'Warning_/_Pass _/ Fail': item.warning_Pass_Fail,
                 Remarks: item.remarks,
                }));
                const jsonValue = JSON.stringify(updatedData)
             updatedElementData[colorGradingIndex].elementValue =
              `DynamicTable|${jsonValue}`;
              combine = updatedElementData;
              });
            }
                const elementNames = [
                  "ORIGINALLTOANDCLONELTO",
                  "CHECKLISTDELIVERABLES",
                  "SUBTITLES",
                  "ALL REPORTS",
                  "Before & After Picture & Audio Restoration Clips",
                  "Images from Picture Restoration",
                  "DCP (Encrypted) QC Report",
                  "DCP (Open) QC Report"

                ];
                  for (const name of elementNames) {
                    const index = combine?.findIndex((element: any) => element.elementName === name);
                    if (index !== -1 && updatedElementData?.[index]?.elementValue === "") {
                      const response:any = name === "ORIGINALLTOANDCLONELTO" 
                                    ? await agent.NFAI.checkparametersCheckReport() 
                                    : name === "CHECKLISTDELIVERABLES" 
                                    ? await agent.NFAI.checkparametersChecklist()
                                    : name === "SUBTITLES" 
                                    ? await agent.NFAI.checkparametersSubtitles()
                                    : name === "ALL REPORTS" 
                                    ? await agent.NFAI.checkparametersAllReports()
                                    : name === "Before & After Picture & Audio Restoration Clips"
                                    ? await agent.NFAI.checkparametersRestorationClips()
                                    : name === "Images from Picture Restoration"
                                    ? await agent.NFAI.checkparametersPictureRestoration()
                                    : name === "DCP (Encrypted) QC Report"
                                    ? await agent.NFAI.checkparametersEncrypted(activity?.title.split('-')[1].trim().split(' ')[0] || '', activity?.id)
                                    : name === "DCP (Open) QC Report"
                                    ? await agent.NFAI.checkparametersOpen(activity?.id)
                                    : [];
                      const updatedData = name === "ORIGINALLTOANDCLONELTO" ? response?.data.map((item: any) => ({
                        "id": item["_uuid_"],
                        "Description": item["description"],
                        "ORIGINAL LTO": item["originaL_LTO"],
                        "CLONE LTO": item["clonE_LTO"],
                      })) 
                      : name === "DCP (Encrypted) QC Report" || name === "DCP (Open) QC Report" 
                      ? response?.data?.map((item: any) => ({
                        "CHECK PARAMETERS": item["check_Parameters"],
                        "TECHNICAL DISCRIPTION": item["technical_Description"],
                        "WARNING / PASS / FAIL": item["warning_Pass_Fail"],
                        "REMARKS": item["remarks"],
                      }))
                      : response?.data?.map((item: any) => ({
                        "id": item["_uuid_"],
                        "CONTENT": item["content"],
                        "ORIGINAL LTO (Y/N)": item["originaL_LTO_YN"],
                        "CLONE LTO (Y/N)": item["clonE_LTO_YN"],
                      }));

                      const jsonValue = JSON.stringify(updatedData);

                      // Update matching element's value
                      updatedElementData[index].elementValue = `DynamicTable|${jsonValue}`;
                      combine = updatedElementData;
                    }
                  }
            const deliverablesIndex = combine.findIndex(
              (element:any) => element.elementName === 'QC REPORT'
            )
            if(deliverablesIndex !== -1 && updatedElementData[deliverablesIndex].elementValue === ''){
              await DeliverablesParameters(activity?.id, selectedSubTask.subTaskId).then((res) => {
               const formatMap = {
                "UHD Apple ProRes 422 HQ 10 bit MOV": "ProRes UHD File Upload",
                "Full HD Apple ProRes 422 HQ 10 bit MOV": "ProRes FHD File Upload",
                "Full HD MP4": "MP4 File Upload",
                "Full HD MP4 with Watermark": "MP4 watermark File Upload"
              };

            //  const updated = combine.map((item: any) => {
            //   if (item.elementName === 'QC REPORT') {
            //     return {
            //       ...item,
            //       enableBydefault: Object.prototype.hasOwnProperty.call(
            //         item.elementName,
            //         res.qC_File_Format
            //       ),
            //     };
            //   }

            //   return item;
            // });


              res = res.map((item:any) => ({
                ...item,
                enableByDefault: formatMap.hasOwnProperty(item.qC_File_Format)
              }));

                const updatedData = res.map((item: any) => ({
                  _uuid_: item._uuid_,
                  QC_File_Format: item.qC_File_Format,
                  Format: item.format,
                  Resolution: item.resolution,
                  Format_Profile: item.format_Profile,
                  Frame_Rate: item.frame_rate,
                  Colour_Space: item.colour_Space,
                  Image_Aspect_Ratio: item.image_Aspect_Ratio,
                  Container_Aspect_Ratio: item.container_Aspect_Ratio,
                  Bit_Depth: item.bit_depth,
                  Restored_Videomix_24_bit_48_KHZ_Used: item.restored_Videomix_24_bit_48_KHZ_Used,
                  Audio_Channel: item.audio_Channel,
                  Audio_Sync: item.audio_Sync,
                  Checksum_Algorithm_Used: item.checksum_Algorithm_Used,
                  Automated_QC_Report_Checked: item.automated_QC_Report_Checked,
                  Total_File_Size: '',
                  SRT_File_Available: item.srT_File_Available,
                  Subtitle_Font_and_Font_Size: item.subtitle_Font_and_Font_Size,
                  SRT_Sync: item.srT_Sync,
                  Watermark: item.watermark,
                  File_Creation_Date: moment(new Date()).format('MM-DD-YYYY'),
                  'Fixity_/_Checksum': '',
                  'Remarks_by_Vendor_QC_Technician/Supervisor': item.remarks_by_Vendor,
                  'Approval_of_Vendor_QC_Technician/Supervisor' : item.approval_of_Vendor_QC,
                  'Any_other_Remarks_by_NFHM_QC_Supervisor_(DOP)': '',
                  'Approval_of_Any_other_Remarks_by_NFHM_QC_Supervisor_(DOP)': '',
                  Performed_By: '',
                  Date_of_QC: moment(new Date()).format('MM-DD-YYYY'),
                  Approved_By: '',
                  Date_of_Approval: moment(new Date()).format('MM-DD-YYYY'),
                  QUALITY_CHECKED_BY_NFHM_DELIVERABLES_SUPERVISOR: '',
                  Date_of_Quality_Checked_By_NFHM_Supervisor: moment(new Date()).format('MM-DD-YYYY'),
                }));
                const jsonValue = JSON.stringify(updatedData)
                updatedElementData[deliverablesIndex].elementValue = `DynamicTable|${jsonValue}`;
                combine = updatedElementData;
              })
            } 
            const imageRestoraitonIndex = combine.findIndex(
              (element: any) =>
                element.elementName === "Image Restoration",
            );
            if(imageRestoraitonIndex !== -1 && activity?.current_task.includes('Final Restoration') && selectedSubTask.subTaskName === 'Restoration'){
              const parsedValue = JSON.parse(combine[imageRestoraitonIndex].elementValue.split('DynamicTable|')[1] || '[]')
              parsedValue.forEach((item:any) => {
                item.Tools_used = "Diamant";
            });
              combine[imageRestoraitonIndex].elementValue =   `DynamicTable|${JSON.stringify(parsedValue)}`
            }
            const DMReportIndex = combine.findIndex(
              (element: any) =>
                element.elementName === "DM Report",
            );
            if (DMReportIndex !== -1 && activity?.current_task.includes('Data Management') && selectedSubTask.subTaskName === 'Data Management') {
              // Parse the elementValue to extract the DynamicTable data
              const parsedValue = JSON.parse(combine[DMReportIndex].elementValue.split('DynamicTable|')[1]);
              // Iterate over the parsed data to calculate Actual Frames and check the condition
              parsedValue.forEach((item: any) => {
                  // Calculate Actual Frames as End Frame - Start Frame + 1
                  const actualFrame =

                    parseInt(item['Start Frame'].toString() || '0') === 0 &&
                    parseInt(item['End Frame'].toString() || '0') === 0
                      ? 0
                      : item['End Frame'] - item['Start Frame'] + 1;
                  item['Actual Frames'] = actualFrame;
                  // Check if Actual Frames equals Total Frames
                  if (actualFrame === parseInt(item['Total Frames'])) {
                      // Set Approved to Yes if Actual Frames match Total Frames
                      item['Approved (Yes / No)'] = 'Yes';
                  } else {
                      // Set Approved to No if Actual Frames don't match Total Frames
                      item['Approved (Yes / No)'] = 'No';
                  }
                   if (item["Approved By (Employee Id)"] === "" || item["Approved By"] === "") {
                    item["Approved By (Employee Id)"] = user?.displayName;
                    item["Approved By"] = user?.displayName;
                  }
                  if (item["Size"] === "") {
                  const bitDepth = viewStore.metadata.find(item => item.elementName === "Bit Depth")?.elementValue;
                  const resolution = viewStore.metadata.find(item => item.elementName === "Resolution")?.elementValue;
                  const totalFrames = parseInt(item["Total Frames"], 10);

                  if (bitDepth && resolution && totalFrames) {
                    // Lookup table with readonly keys
                    const sizeLookup = {
                      "10_4K": 56.5,
                      "10_2K": 14.1,
                      "16_4K": 85.5,
                      "16_2K": 21.3
                    } as const;

                    // Create type-safe union of keys
                    type SizeKey = keyof typeof sizeLookup;

                    // Construct lookup key and assert as valid union
                    const key = `${bitDepth}_${resolution}` as SizeKey;

                    if (key in sizeLookup) {
                      const mbPerFrame = sizeLookup[key];
                      const totalSizeMB = mbPerFrame * totalFrames;
                      const totalSizeTB = totalSizeMB / 1000000;

                      item["Size"] = `${totalSizeTB.toFixed(2)} TB`;
                    } else {
                      console.warn("Unsupported Bit Depth or Resolution:", key);
                    }
                  } else {
                    console.warn("Missing metadata: Bit Depth, Resolution, or Total Frames");
                  }
                }
              });
          
              // Update the elementValue with the modified parsedValue
              combine[DMReportIndex].elementValue = `DynamicTable|${JSON.stringify(parsedValue)}`;
          }

          if(selectedSubTask.subTaskName === "Consolidated Restoration Report and Quality Sign Off") {
            combine.forEach((x,index) => {
              const findValue = masteringStore.consolidateList.find(element => element.elementName === x.elementName);
              if(findValue && findValue.elementValue !== ""){ 
                  combine[index].elementValue = findValue.elementValue
              }
            })
          }
          }
          
          setLocalDataElement(combine || []);
        }
      });
  };

  /** ------------ fetch elements data from API -------------- */
  const fetchData = async () => {
    if(selectedSubTask.subTaskName === "Consolidated Restoration Report and Quality Sign Off") {
        let DeliverablesId = "";
        let NFHMColorGradingId = "";
        let RestorationId = "";
        const findDeliverablesId = getFirstSubtaskIdByName(activeOrder || [],"Deliverables QC Report");
        DeliverablesId = findDeliverablesId || "";

        const findNFHMColorGradingId = getFirstSubtaskIdByName(activeOrder || [],"NFHM Color Grading QC");
        NFHMColorGradingId = findNFHMColorGradingId || "";

        const findRestorationId = getFirstSubtaskIdByName(activeOrder || [],"Restoration");
        RestorationId = findRestorationId || "";

          await conslidatedApiCall(activity?.id, selectedSubTask?.subTaskId || "", DeliverablesId, NFHMColorGradingId, RestorationId);
    }
    let data;
    if (selectedSubTask?.subTaskId !== undefined) {
      data = selectedSubTask?.subTaskId;
    } else {
      data = selectedSubTask?.[0]?.subTaskId;
    }
    let results = await agent.subtaskStatus.subtaskElementsAPI(data);
    setApiSettings(results?.data?.api);
    setWorkFlowCommunication(results?.data?.communication);
    setActionerName(results?.data?.actionerName || '');
     setElementLength(results?.data?.elements?.length);
    // setSmartTrackeractionerName(results?.data?.actionerName || '');
    let copyElements = [...(results?.data?.elements || [])];
    copyElements?.sort((a: any, b: any) => {
      return a.elementIndex - b.elementIndex;
    });
    copyElements = copyElements.map((element: any) =>
      element.elementName === 'QC REPORT'
        ? {
            ...element,
            elementValue: normalizeDeliverablesQcElementValue(element.elementValue),
          }
        : element
    );
    // masters
    let mastersHashmap: any = {};
    const mastersListOptions = async (
      masterId: string,
      componentName: string,
    ) => {
      const payload = {
        name: masterId,
        componentName,
        filterColumn: '',
        filterValue: '',
        receivingDate: '',
        returnDate: '',
      };
      let result: any = await agent.WorkLevels.mastersListAPI(payload);
      let returnData = await (result || [])?.map((data: string) => {
        return {
          key: data,
          value: data,
          text: data,
        };
      });
      return returnData;
    };
    let filterMasters = copyElements?.filter(
      (data: { elementType: string }) => data.elementType === 'Masters',
    );
    filterMasters?.forEach(async (data: any) => {
      let result = await mastersListOptions(
        data.elementValue?.split('|')?.[0],
        data.selectMasterComponent,
      );
      mastersHashmap[`${data.elementValue?.split('|')?.[0]}`] = result;
      setMasterList(mastersHashmap);
    });
    // users
    let usersHashmap: any = {};
    const usersListOptions = async (userId: string) => {
      let result: any = await agent.WorkLevels.usersListAPI(userId);
      let returnData = await (result || [])?.map((data: string) => {
        return {
          key: data,
          value: data,
          text: data,
        };
      });
      return returnData;
    };
    let filterUsers = copyElements?.filter(
      (data: { elementType: string }) => data.elementType === 'Users',
    );
    filterUsers?.forEach(async (data: { elementValue: string }) => {
      let result = await usersListOptions(data.elementValue?.split('|')?.[0]);
      usersHashmap[`${data.elementValue?.split('|')?.[0]}`] = result;
      setUserList(usersHashmap);
    });
    configureLocalElement(copyElements);
  };
  const isFinishCheck = async () => {
    HistoryPost(`completed ${selectedSubTask.subTaskName} for `);
    setCurrStatus(2);
    await sendCurrentWorkflowData('Completed', 2);

    //Consolidated Restoration Report and Quality Sign Off Subtask No of Frames purpose 
    
    if(selectedSubTask.subTaskName === "Data Management") { 
      const dmreport = metadata.find(e => e.elementName === "DM Report") || "";
      if(dmreport){
        const parsedValue = JSON.parse(dmreport?.elementValue.split("DynamicTable|")[1]);
        try {
          const consolidate = viewStore.activeOrder?.tasks?.find(e => e.taskName === "Consolidated Restoration Report and Quality Sign Off")?.subTasks[0];
          const sumFrames = (key: keyof DmFramesReel, body: DmFramesReel[]): number => 
                      body.reduce((total, obj) => 
                        total + obj[key].split("\t").map(Number).reduce((acc, cur) => acc + cur, 0)
                      , 0);
          const totalFrames = sumFrames("Total Frames", parsedValue);
          await agent.NFAIReport.NoOfframes(consolidate?.subTaskId || "",totalFrames.toString())
        } catch (error) {
          console.log(`taskformmodel line number 833 ${error}`);
        }
      }
    }
  };

  const openCompleted = async () => {
    if (commonStore.NFAIReportCustomer) {
      const condtionArr = NFIARestotoast();
      if(condtionArr.length > 0){
        const uniqueArray1 = condtionArr.filter((item:any, index:any) => condtionArr.indexOf(item) === index);
        toast.info(`please fill ${uniqueArray1}`)
        return;
      }
      const [toastArr] = handleDynamicTableManitory();
        if (toastArr.length > 0) {
          const uniqueArray = toastArr.filter((item:any, index:any) => toastArr.indexOf(item) === index);
          toast.info(`Please fill ${uniqueArray.join(', ')}`);
          setCancelModelAPI((p) => ({ ...p, isLoading: false }));
          return;
        }
        if(selectedSubTask.subTaskName === 'NFHM Color Grading QC' && isNFAITableCheck !== ''){
          setCancelModelAPI((p) => ({
            ...p,
            isLoading: false,
          }));
          toast.info(isNFAITableCheck)
          return;
        }
        await eleFormSubmittion('completeTask');
    } 
   
    if (user?.customerName === 'NFAIReport' && selectedSubTask?.subTaskName === "Restoration") {
      try {
        const getColorGradingTaskId = (tasks: any) => {
          if (!Array.isArray(tasks)) return null;
          const colorGradingTask = tasks.find(task => task.taskName === "Color Grading");
          return colorGradingTask ? colorGradingTask.taskId : null;
        }      
        const nextTaskId = getColorGradingTaskId(taskData.tasks)
        const params = {
          workflowTaskId: nextTaskId,
          itemId: activity?.id || ""
        };
        const response = await agent.NFAIReport.NFAITaskActivate(params);
        if (response?.status === 200) {
          toast.success("Color Grading task activated successfully!");
        } else {
          toast.error("Failed to activate Color Grading task");
          console.error("API Response:", response);
          return;
        }
      } catch (error) {
        console.error("Error calling NFAITaskActivate:", error);
        toast.error("Something went wrong while activating Color Grading task");
        return;
      }
    }

    if (user?.customerName === 'NFAI' || commonStore.hfcCustomerChanges) {
      await eleFormSubmittion('completeTask');
    } else if (user?.customerName === 'BroekmanLogistics') {
      const isPendingAndDropDown = localElementData.some(
        (item: any) =>
          item.elementValue.includes('Pending') &&
          item.elementType.includes('DropDown'),
      );

      if (isPendingAndDropDown) {
        toast.info('Process is pending !');
      } else {
        await eleFormSubmittion('completeTask');
      }
    }else{
      if (user?.customerName !== 'NFAIReport') {
      await isFinishCheck();
    }
    }

    // if (user?.customerName === 'NFAIReport') {
    //   await eleFormSubmittion('completeTask');
    // } 

    // else {
    //   setIsSaveClicked(true);
    //   let isMandatory = false;
    //   for (let i = 0; i < localElementData?.length; i++) {
    //     //------------ mandatory fields checking ------------//
    //     let localErrMsg = Object.assign({}, errorMessage);
    //     if (mandatoryFieldsRef.current[`${localElementData[i].elementId}`]) {
    //       localErrMsg[`${localElementData[i].elementId}`] =
    //         'This is mandatory field';
    //       isMandatory = true;
    //       setErrorMessage(localErrMsg);
    //     }
    //   }
    //   if (isMandatory) {
    //     toast.error('Kindly fill appropriate input');
    //     setCancelModelAPI((p) => ({
    //       ...p,
    //       isLoading: false,
    //     }));
    //     return;
    //   } else {
    //     await eleFormSubmittion();
    //   }
    // }

    // let resp: any;
    // let p1 = new Promise(async (resolve) => {
    //   if (selectedSubTask?.api?.length) {
    //     resp = await ElementStore.postAPITemp(subTaskIdNo, activity?.id || '');
    //   }
    //   resolve('');
    // });

    // p1.then(async () => {
    //   setTimeout(() => {
    //     if (resp === '' || !selectedSubTask?.api?.length) {
    //       if (!SmartTrackerReports) {
    //         HistoryPost('completed  ' + selectedSubTask.subTaskName);
    //       }
    //       setCurrStatus(2);
    //       sendCurrentWorkflowData('Completed', 2);
    //     } else if (resp === 'no') {
    //       closeTaskFormModal(true);
    //     }
    //   }, 2000);
    // });
  };

  const openHold = async () => {
    HistoryPost(`holded ${selectedSubTask.subTaskName} for `);
    setCurrStatus(3);
    await sendCurrentWorkflowData('Hold', 3);
    if(commonStore.NFAIReportCustomer){
      await  eleFormSubmittion('')
    }
  };

  const openReject = async () => {
    setIsRejectModalOpened(true);
    // mediaAssetStore.openMediaAssetRejectModal(true);
  };

  const openResume = async () => {
    HistoryPost(`resumed working on ${selectedSubTask.subTaskName} for `);

    setCurrStatus(4);
    await sendCurrentWorkflowData('Resume', 4);
  };

  const openResolve = () => {
    setIsResolveModalOpened(true);
    setCurrStatus(2);
    // setting the main modal false
    getTotalCountsOfTask(activeOrder.templateId || '');
    mediaAssetStore.simpleModalOpen(false);
    mediaAssetStore.mediaAsset.tasknamemsg =
      taskname || (activityStore?.selectedActivity?.current_task as string);
    mediaAssetStore.mediaAsset.subtaskmsg = selectedSubTask.subTaskName;
    mediaAssetStore.openMediaAssetResolveModal(true);
  };

  const collectSelectVal = (
    e: any,
    data: any,
    _optionData: WorkflowOptions[],
    index: number,
    isMultiple?: boolean,
    previousValue?: string,
  ) => {
    if (e.keyCode === 'Backspace' || e.keyCode === 'Delete') {
      e.stopPropagation();
      return;
    }
    let copy: any = [...localElementData];

    function updateElementHandler() {
      for (let i = 0; i < copy?.length; i++) {
        if (copy[i].elementId === data.id) {
          let value = '';
          if (isArray(data.value)) {
            value = data.value.join('|');
          } else {
            value = data.value;
          }
          copy[i].elementValue = value;
        }
        for (let j = 0; j < copy[i]?.options?.length; j++) {
          let linkID = '';
          if (data.value?.includes(copy[i]?.options?.[j]?.optionName)) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
          let newLinkId = linkID?.split('|');
          for (let x = 0; x < newLinkId?.length; x++) {
            let foundIndex = copy.findIndex(
              (localData: { templateElementId: string }) => {
                return newLinkId[x] === localData.templateElementId;
              },
            );
            if (copy?.[foundIndex] !== undefined) {
              if (
                copy?.[foundIndex].isMandatory &&
                copy?.[foundIndex]?.elementValue?.length === 0
              ) {
                mandatoryFieldsRef.current[`${copy?.[foundIndex].elementId}`] =
                  copy?.[foundIndex].elementId;
              }
              copy[foundIndex].enableByDefault = true;
            }
          }
        }
      }
    }

    if (!isMultiple) {
      let addLinkID = '';
      let removeLinkID = '';
      if (copy?.[index]) copy[index].elementValue = data.value;
      for (let j = 0; j < copy[index].options?.length; j++) {
        if (previousValue === copy[index]?.options?.[j]?.optionName) {
          removeLinkID = copy[index]?.options?.[j]?.optionLinkId;
        }
        if (data.value === copy[index]?.options?.[j]?.optionName) {
          addLinkID = copy[index]?.options?.[j]?.optionLinkId;
        }
      }
      for (let i = 0; i < copy?.length; i++) {
        if (copy[i]?.templateElementId === removeLinkID) {
          if (copy?.[i] !== undefined) {
            delete mandatoryFieldsRef.current[`${copy?.[i]?.elementId}`];
            copy[i].enableByDefault = false;
          }
        }
        if (copy[i]?.templateElementId === addLinkID) {
          if (copy?.[i] !== undefined) {
            mandatoryFieldsRef.current[`${copy?.[i]?.elementId}`] =
              copy?.[i].elementId;
            copy[i].enableByDefault = true;
          }
        }
      }
      updateElementHandler();
    }
    if (e.target.className === 'delete icon') {
      for (let i = 0; i < copy?.length; i++) {
        let linkID = '';
        for (let j = 0; j < copy[i].options?.length; j++) {
          if (
            e.currentTarget.parentElement.text ===
            copy[i]?.options?.[j]?.optionName
          ) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
        }
        let newLinkId = linkID?.split('|');
        for (let x = 0; x < newLinkId?.length; x++) {
          let foundIndex = copy.findIndex(
            (localData: { templateElementId: string }) =>
              newLinkId[x] === localData.templateElementId,
          );
          if (copy?.[foundIndex] !== undefined) {
            delete mandatoryFieldsRef.current[
              `${copy?.[foundIndex]?.elementId}`
            ];
            copy[foundIndex].enableByDefault = false;
          }
        }
      }
      updateElementHandler();
    } else {
      updateElementHandler();
    }
    setLocalDataElement(copy);
  };
  const saveDynamicTableData = async (
    data: any,
    validationData: any,
    removed: any,
    added: any,
    // alterHistory: string,
    initialElementValue: any,
    headers: columnType[],
  ) => {
    let copyElements = [...localElementData];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let payload = {
      ...validationData,
      elementValue:
        validationData?.elementName === 'QC REPORT'
          ? 'DynamicTable|' + JSON.stringify(normalizeDeliverablesQcRows(data))
          : 'DynamicTable|' + JSON.stringify(data),
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      copyElements[indexOfData] = payload;
    } 
    if(NFAIApisettings.imageRestoration.length > 0){
      const index = copyElements.findIndex((item:any)=>item.elementName === 'imageRestoration');
      if(index !== -1){
        copyElements[index] = NFAIApisettings.imageRestoration[index];
      }
    }
    if(NFAIApisettings.NFAI_AVSyn_Remarks.length > 0){
      const index = copyElements.findIndex((item:any)=>item.elementName === 'NFAI AVSyn Remarks');
      if(index !== -1){
        copyElements[index] = NFAIApisettings.NFAI_AVSyn_Remarks[index];
      }
    }
    setLocalDataElement(copyElements);
    if (removed.length > 0) {
      setRemovedRow((temp: any) => ({ ...temp, [validationData?.elementId]: removed }));
    }
  
    if (added.length > 0) {
      setAddedRow((temp: any) => ({ ...temp, [validationData?.elementId]: added }));
    }
  
    // Update headers
    if (headers) {
      setDataGridHeaders((tempValue) => ({
        ...tempValue,
        [validationData?.elementId]: [...headers],
      }));
    }
  
    // Update initialElementValue
    if (initialElementValue) {
      setDataGridInitialValue((tempValue) => ({
        ...tempValue,
        [validationData?.elementId]: [...initialElementValue],
      }));
    }
  };
  const onChangeHandler = async (e: any, data: any, validationData: any) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      e.stopPropagation();
      return;
    }

    let copyElements = [...localElementData];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let previousValue = copyElements[indexOfData]?.elementValue || '';
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let value = /datepicker/gi.test(validationData?.elementType || '')
      ? e?.toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        })
      : validationData?.elementType === 'DateTime'
        ? new Date(data).toDateString() +
          ' ' +
          new Date(data).toString().split(' ')[4]
        : data.value;
    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: value,
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    if (/textbox/gi.test(validationData?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        validationData?.validation || '',
      );
    }
    if (validationData?.isMandatory && !value?.length) {
      result = 'This is mandatory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }
    setErrorMessage(errorTemp);

    if (/dropdown/gi.test(validationData?.elementType || '')) {
      collectSelectVal(
        e,
        data,
        [],
        indexOfData,
        copyElements[indexOfData].isMultiple,
        previousValue,
      );
      return;
    }
    setLocalDataElement(copyElements);
  };


  const startProject = async () => {
    if(commonStore.NFAIReportCustomer){
      if(selectedSubTask?.subTaskName === 'AV Sync'){
        try {
          const response = await agent.NFAIReport.AVSyncfromParrent(activity?.id);
          if(response.data.length === 0){
            toast.info('Please upload AVSync File...')
            return;
          }
        } catch (error) {
          toast.info('Please upload AVSync File...')
          return;
        }
        
      }
      if(selectedSubTask?.subTaskName === 'Data Management'){
        const ClonedComponent = await agent.Reports.sectionMultipledetails(activity?.id);
        if(ClonedComponent.length === 0){ 
          toast.info('Kindly upload reels to start the Data Management task.');
          return;
        }
      } 
      const isRestorationTask = selectedSubTask?.subTaskName?.toLowerCase() === 'restoration';
      if (isRestorationTask) {  
        const imageRestorationElement = localElementData.find(
          (e: any) => e.elementName === 'Image Restoration'
        );
        const noImageRestorationValue = !imageRestorationElement?.elementValue;
        if (noImageRestorationValue) {
          await agent.NFAIReport.CutlistAggregation(activity?.id);
        }
      }
  // if(activity?.title.includes('Cutlist ') && taskname === 'Full Restoration' && selectedSubTask?.subTaskName === 'Restoration'){
  //     try {
  //       await HandleCutlistReelAnaylsis(itemDetails.parent?.split('/')[0] || '');
  //       if(viewStore?.NFAIReportCutlistCheck){
  //         toast.info('Reel Analysis file has to upload to start cutlist ');
  //         return;
  //       }
  //     } catch (error) {
  //       console.log('Cutlist start paresed error', error);
  //     }
  //   } 
    // if(!activity?.title.includes('Cutlist ') && !activity?.title.includes('Reel') && selectedSubTask?.subTaskName === 'Restoration'){
    //   setCancelModelAPI((p) => ({ ...p, isLoading: true }));
    //   setNFAIReportLoader(true)
    //   const response = await agent.NFAIReport.CutlistVerification(activity?.id);
    //   if(response.data.length > 0){
    //     if(response.data[0].includes('Cutlist')){
    //       response.data.sort((a:any, b:any) => {
    //       const numsA = a.match(/\d+/g);
    //       const numsB = b.match(/\d+/g);
    //       return numsA[0] - numsB[0] || numsA[1] - numsB[1];
    //      });
    //     }else{
    //       response.data.sort((a:any, b:any) => parseInt(a.split(" ")[2]) - parseInt(b.split(" ")[2]));
    //     }
    //     toast.info(`Kindly complete the following cutlist workflow ${response.data} to start the restoration process.`);
    //     setNFAIReportLoader(false)
    //     setCancelModelAPI((p) => ({ ...p, isLoading: false }));
    //     return;
    //   }
    //   setNFAIReportLoader(false)
    //   setCancelModelAPI((p) => ({ ...p, isLoading: false }));

    // }
  }
    if (nfaiToast !== '') {
      toast.info(nfaiToast);
    } else {
      // if (TrackingReportStore.CurrentSubtaskStatus.status === '') {
      //   await agent.subtaskStatus.updateSubtaskActionerNameAPI(
      //     selectedSubTask?.subTaskId,
      //   );
      // }
      HistoryPost(`started working on ${selectedSubTask.subTaskName} for `);

      setCurrStatus(1);
      await sendCurrentWorkflowData('Started', 1);
      
    }
  };

  const HistoryPost = async (data: string) => {
    mediaAssetStore.mediaAsset.openStart = true;
    if (activity !== undefined) {
      const payload = {
        taskId: taskId,
        taskName: taskname,
        subTaskId: selectedSubTask.subTaskId,
        subTaskName: selectedSubTask.subTaskName,
        status: data,
        date: new Date(),
      };
      await updateHistoryMain(
        payload,
        SmartTrackerReports,
        false,
        SmartTrackerReports,
      );
      let mailBody = '';
      if (!data.includes('resolved')) {
        mailBody = `Dear ${user?.displayName},<br/>\u00A0 This notification is to inform you that you have ${data}${activity?.title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`;
      } else {
        mailBody = `Dear ${user?.displayName},<br/>\u00A0 This notification is to inform you that you have resolved "${selectedSubTask.subTaskName}" to "${getResolvedId.name}" for ${activity?.title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`;
      }
      sendRespectiveEmail(
        'edited',
        activity.title,
        'Edited WorkFlow in Asset',
        '',
        '',
        '',
        mailBody,
      );
      // if (smartTrackButtonLabel === 'Reject') {
      //   reportWorflowUpdate();
      // }
    }
  };

  const generatePdfFunction = async () => {
    const generateData = (_dat: any) => {
      const result: any[] = [];
      localElementData?.forEach((data: any) => {
        if (
          data.elementValue?.length !== '' ||
          data.files.length > 0 ||
          data.photos.length > 0
        ) {
          const description =
            data.elementType !== 'Dynamicmetadata' && data.elementName;
          let value =
            data.elementType !== 'DynamicTable'
              ? isArray(data.elementValue)
                ? data.elementValue?.join(', ')
                : data.elementValue?.replaceAll('|', ', ')
              : data.elementValue;
          if (data.elementType === 'AddFiles' && data.files.length > 0) {
            const fileNamesList: string[] = [];
            data.files?.forEach((f: FileType) => {
              fileNamesList.push(f.url);
            });
            value = fileNamesList.join(', ');
          }
          if (data.elementType === 'AddPhotograph' && data.photos.length > 0) {
            const photoNames: string[] = [];
            data.photos?.forEach((p: PhotoType) => {
              photoNames.push(p.url);
            });
            value = photoNames.join(', ');
          }
          if (data.elementType === 'DynamicTable') {
            const stringData = value?.split('DynamicTable|')?.[1];
            let tempValue =
              stringData !== undefined ? JSON.parse(stringData) : [];
            const rowsList: string[] = [];
            let columnHeaders: string[] = [];
            tempValue?.forEach((val: any) => {
              columnHeaders = Object.keys(val);
            });
            columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
            tempValue?.forEach((val: any) => {
              let rowVal = '';
              columnHeaders?.forEach((header: string, index: number) => {
                rowVal += header?.split('_')?.join(' ');
                rowVal += ': ';
                rowVal += val?.[header];
                if (index !== columnHeaders.length - 1) {
                  rowVal += ', ';
                }
              });
              rowsList.push(rowVal);
            });
            value = rowsList.join('\n');
          }
          const elementDataTable: any = {
            Description: description,
            Values: value,
            //            data?.elementType === "Dynamicmetadata"  ?
            // metaDataVal?.metadata?.map(
            //        (dataa: any) =>
            //        dataa?.name === data?.elementValue &&
            //      dataa?.value?.replaceAll('|', ', ')
            //       )
            // data?.elementValue=== "Dynamicmetadata" ? data?.elementValue
            //                :
          };
          data.id = '1';
          result.push(Object.assign({}, elementDataTable));
        }
      });
      return result;
    };

    const createHeaders = (keys: any) => {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 133,
          align: 'center',
          padding: 0,
        });
      }
      return result;
    };

    const headers: any = createHeaders(['Description', 'Values']);
    const doc = new jsPDF({
      putOnlyUsedFonts: true,
      orientation: 'portrait',
    });
    let xPos = 5;
    let yPos = 35;
    doc?.addImage('../../assets/logo.png', 'JPEG', 80, 6, 65, 20);
    doc?.setFontSize(14);
    doc?.text('Title: ' + activity?.title, xPos, yPos);
    doc?.setFontSize(14);
    yPos += 10;
    doc?.text('Task:' + taskname, xPos, yPos);
    doc?.setFontSize(14);
    yPos += 10;
    doc?.text('Sub Task:' + selectedSubTask.subTaskName, xPos, yPos);
    yPos += 10;
    if (!commonStore.devEnv) {
      localElementData?.forEach((data: any) => {
        if (data.elementType === 'AddPhotograph' && data.photos?.length > 0) {
          data.photos?.forEach((p: PhotoType) => {
            doc?.text(data.elementName, xPos, yPos);
            doc?.addImage(p.url, 'JPEG', xPos + 80, yPos, 25, 25);
            yPos += 30;
          });
        }
      });
    }
    doc?.table(xPos, yPos + 2, generateData(180), headers, {
      autoSize: false,
    });

    // const fileName:any = eleVal[2];

    let subTaskConst: uploadFileType = {
      id: '',
      files: [],
    };
    let response: any = [];
    if (commonStore.devEnv) {
      const item = activity?.id;
      const workLevel = dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
      const FilePDF: File = new File(
        [doc.output('blob')],
        `${taskname + '_' + selectedSubTask.subTaskName}.pdf`,
      );
      response = await agent.Files.localFileUpload(FilePDF, workLevel, item);
      Object.assign(response.data, { fileId: uuid() });
      response.data.id = uuid();
      response.data.fileName = taskname + '_' + selectedSubTask.subTaskName;
      subTaskConst = {
        // subTaskId: subTaskIdNo,
        id: item,
        files: [
          {
            ...response.data,
            addedOn: new Date(),
          },
        ],
      };
    } else {
      const blobPDF: any = new Blob([doc.output('blob')], {
        type: 'application/pdf',
      });
      response = await agent.Files.uploadFile(blobPDF);
      Object.assign(response.data, { fileId: uuid() });
      response.data.id = uuid();
      response.data.fileName = taskname + '_' + selectedSubTask.subTaskName;
      subTaskConst = {
        // subTaskId: subTaskIdNo,
        id: activity?.id,
        files: [
          {
            ...response.data,
            addedOn: new Date(),
          },
        ],
      };
    }

    //history
    // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder} from ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue} to ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue} `,activity?.title)//history
    // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder} from ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue} to ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue} `,activity?.title)//working history
    // mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue + mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue + mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder +
    // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder +  `from ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue}` + `to ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue}` + "," + `updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder}` + `from ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue}` + `to ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue}`}`,activity?.title)//history
    await generatePdf(subTaskConst);
    setTimeout(() => {
      if(!SmartTrackerReports){
        getItemPageFilesStructure({
          itemId: activityStore?.selectedActivity?.id,
        });
      }
    }, 300);

    if (commonStore.devEnv && !SmartTrackerReports) {
      setTimeout(() => {
        dashboardStore.getLocalFilesBasedOnItem(activity?.id);
      }, 200);

    }
  };

  const onPhotoClick = (index: number) => {
    setPhotoIndex(index);
    dashboardStore.setOpenCameraModal(true);
  };

  const mastersAndUsersHandler = (e: any, data: any) => {
    let copyElements = [...localElementData];
    let findIndex = copyElements?.findIndex(
      (localData) => localData.elementName === data.name,
    );
    let masterOrUser = copyElements[findIndex].elementValue?.split('|');
    if (copyElements[findIndex]?.elementName === data.name) {
      let name = masterOrUser?.[0];
      let value = data.value;
      value = `${name}|${value}`;
      copyElements[findIndex].elementValue = value;
    }

    if (masterOrUser) {
      delete mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`];
    } else {
      mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`] =
        copyElements[findIndex].elementId;
    }
    setLocalDataElement(copyElements);
  };

  const getUploadedFiles = (uploadedFiles: FileType, index: number) => {
    let temp: any = [];
    if (uploadedFiles?.url) {
      setTemporaryFilePath((temporaryFilePath) => [
        ...temporaryFilePath,
        uploadedFiles.url,
      ]);
    }
    if (uploadedFiles?.id !== '') {
      temp = [...localElementData];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].elementId === index) {
          temp[i].files.push(uploadedFiles);
        }
      }
      setLocalDataElement(temp);
    }
  };

  const getUploadedPhotos = (uploadedPhotos: PhotoType, index: number) => {
    let temp: any = [];
    if (uploadedPhotos?.url) {
      setTemporaryFilePath((temporaryFilePath) => [
        ...temporaryFilePath,
        uploadedPhotos.url,
      ]);
    }
    if (uploadedPhotos?.id !== '') {
      temp = [...localElementData];
      temp[index]?.photos.push(uploadedPhotos);
      setLocalDataElement(temp);
    }
  };

  useEffect(() => {
    if (getResolvedId.id !== undefined && getResolvedId.id !== '') {
      if (!SmartTrackerReports) {
        sendCurrentWorkflowData('Resolved', 7);
        triggerResolve({
          id: '',
          name: '',
        });
        hideSubtask(false);
      } else {
        triggerResolve(getResolvedId);
        // setTimeout(() => {
        //   if (currentClickedStatusNo === 7) {
        //     // eslint-disable-next-line
        //     restrictApiWorkflowToTemplate =
        //       'Complete_subtask';
        //   }
        // }, 500);
      }
    }
    // eslint-disable-next-line
  }, [getResolvedId]);

    useEffect(() => {
  if (!commonStore.NFAIReportCustomer) return;
  if (localElementData.length === 0 || !localElementData) return;

  // Define the sequential upload chain - STARTING WITH UHD
  const uploadChain = [
    { checksum: 'ProRes UHD Check Sum Upload', file: 'ProRes UHD File Upload' },
    { checksum: 'ProRes FHD Check Sum Upload', file: 'ProRes FHD File Upload' },
    { checksum: 'MP4 Check Sum Upload', file: 'MP4 File Upload' },
    { checksum: 'MP4 watermark Check Sum Upload', file: 'MP4 watermark File Upload' },
  ];

  // Helper: Find element index by name
  const findElementIndex = (name: string): number => {
    return localElementData.findIndex((element: any) => element.elementName === name);
  };

  // Helper: Check if files exist for an element
  const hasFiles = (index: number): boolean => {
    if (index === -1) return false;
    const files = localElementData[index]?.files;
    return files && files.length > 0;
  };

  // Helper: Check if element is locked
  const isLocked = (index: number): boolean => {
    if (index === -1) return false;
    return localElementData[index].readOnly !== false;
  };

  let needsUpdate = false;
  const temp = [...localElementData];

  // Process the upload chain
  for (let i = 0; i < uploadChain.length; i++) {
    const { checksum, file } = uploadChain[i];
    
    const checksumIndex = findElementIndex(checksum);
    const fileIndex = findElementIndex(file);

    // Rule 1: Checksum uploaded → unlock its corresponding File
    if (hasFiles(checksumIndex) && isLocked(fileIndex)) {
      temp[fileIndex] = { ...temp[fileIndex], readOnly: false };
      needsUpdate = true;
    }

    // Rule 2: File uploaded → unlock next Checksum in the chain (if exists)
    if (i < uploadChain.length - 1) {
      const nextChecksumIndex = findElementIndex(uploadChain[i + 1].checksum);
      if (hasFiles(fileIndex) && isLocked(nextChecksumIndex)) {
        temp[nextChecksumIndex] = { ...temp[nextChecksumIndex], readOnly: false };
        needsUpdate = true;
      }
    }
  }

  // Handle 2K Resolution Exception
  const resolution = metadata.find((element) => element.elementName === "Resolution")?.elementValue || "";
  
  if (resolution && resolution.toString() === "2K") {
    const uhdChecksumIndex = findElementIndex('ProRes UHD Check Sum Upload');
    const uhdFileIndex = findElementIndex('ProRes UHD File Upload');
    const fhdChecksumIndex = findElementIndex('ProRes FHD Check Sum Upload');

    // For 2K: Disable UHD entirely, enable FHD checksum to start the flow
    if (
      uhdChecksumIndex !== -1 &&
      uhdFileIndex !== -1 &&
      fhdChecksumIndex !== -1 &&
      (temp[uhdChecksumIndex].enableByDefault !== false ||
       temp[uhdFileIndex].enableByDefault !== false ||
       temp[fhdChecksumIndex].readOnly !== false)
    ) {
      temp[uhdChecksumIndex] = { ...temp[uhdChecksumIndex], enableByDefault: false };
      temp[uhdFileIndex] = { ...temp[uhdFileIndex], enableByDefault: false };
      temp[fhdChecksumIndex] = { ...temp[fhdChecksumIndex], readOnly: false };
      needsUpdate = true;
    }
  }

  // Only update state if changes were made
  if (needsUpdate) {
    setLocalDataElement(temp);
  }
   //eslint-disable-next-line
}, [localElementData, metadata]);

const sendCurrentWorkflowData = async (
  statusName: string,
  statusNumber: number,
  rejectNotify?: { email: string; body: string; reason: string },
) => {
  if(commonStore.NFAIReportCustomer){
    setCancelModelAPI((p) => ({
      ...p,
      isLoading: true,
    }));
    setNFAIReportLoader(true)
  }
  if (statusNumber === 2 && SmartTrackerReports) {
    CurrentSubtaskStatus.status = '';
    CurrentSubtaskStatus.value = 0;
    currWorkflowModel = false;
  }
  selectedSubTask.status = statusNumber;
  actionerNameHandler(user?.displayName || '');
  
  const payload = {
    itemId: activity?.id,
    currentTask: taskname || activity?.current_task || '',
    currentSubtask: selectedSubTask.subTaskName,

    actionerName: user?.displayName || '',
    resolveSubtaskId:
      smartTrackButtonLabel === 'Completed'
        ? ''
        : getResolvedId?.id?.split('|')[0],
    status: statusNumber,
  };
  // const nextTaskId = getNextTaskId(taskData.tasks, taskId,currSubTaskData.subTaskId);
  // const nextSubTaskId = getNextSubTaskId(taskData.tasks, taskId, currSubTaskData.subTaskId);
  const { nextTaskId, nextSubtaskId, afterRejectSubtaskName } = getNextTaskOrSubTaskId(taskData.tasks, taskId, currSubTaskData.subTaskId)
  const NFAIpayload ={
    itemId: activity?.id,
    templateId: taskData.templateId,
    currentTaskId:taskId,
    nextTaskId: nextTaskId,
    currentSubtaskId: currSubTaskData.subTaskId,
    nextSubTaskId: nextSubtaskId,
    actionerName: user?.displayName || '',
    status: statusNumber,
    taskCount: 0,
    totalTask:taskData.tasks.length,
    afterRejectSubtaskName: afterRejectSubtaskName
  }
 
  try {
    if (user?.customerName === 'NFAIReport') {
      await NFAIworkFlowProcessChangesUpdate(NFAIpayload)
    } else {
      await workFlowProcessChangesUpdate(payload);
    }
      setTimeout(async () => {
        if (apiSettings.length > 0) {
          if (user?.customerName === 'NFAIReport') {
            const updateElementData = (elementName: string, value: any) => {
              const index = localElementData.findIndex((element: any) => element.elementName === elementName);
              if (index !== -1) {
                const updatedElementData = [...localElementData];
                updatedElementData[index].elementValue = value;
                viewStore.updateApisettingsValue(updatedElementData, elementName);
              }
            };
            
            const apiSettingFunction = async () => {
              try {
                const response: any = await agent.workflowStatus.sendAPITemp(
                  subTaskIdNo,
                  activity?.id || '',
                  statusNumber !== 0 ? statusNumber.toString() : null,
                );
            
                if (!response?.data) return;
            
                const { elementName, elementValue } = response.data;
            
                switch (elementName) {
                  case 'Image Restoration':
                    const dynamicValue =
                      elementValue === undefined
                        ? `DynamicTable|${JSON.stringify([response.data[0]])}`
                        : elementValue || '';
                    updateElementData('Image Restoration', dynamicValue);
                    break;
            
                  case 'Overall Remark':
                    updateElementData('Overall Remark', elementValue);
                    break;
            
                  case 'NFAI AVSyn Remarks':
                    updateElementData('NFAI AVSyn Remarks', elementValue);
                    break;
            
                  default:
                    break;
                }
            
                await getActiveOrder({ itemId: activity?.id || '' });
              } catch (error) {
                // Handle error (e.g., falseCondition());
              }
            };
            
            const imageRestorationDetails = localElementData.find((element: any) => element.elementName === 'Image Restoration')?.elementValue;
            
            const isTaskAndSubtaskNotRestoration =
              taskname === 'Final Restoration' &&
              selectedSubTask?.subTaskName?.includes('Restoration');
            
            if (isTaskAndSubtaskNotRestoration) {
              if(imageRestorationDetails === '') {
                await apiSettingFunction();
                await getActiveOrder({ itemId: activity?.id || '' });
              }
            } else {
              await apiSettingFunction();
              await getActiveOrder({ itemId: activity?.id || '' });
            }
            
          } else {
            await postAPITemp(   
              subTaskIdNo,
              activity?.id || '',
              statusNumber !== 0 ? statusNumber.toString() : null,
            );
          }
          if(commonStore.NFAIReportCustomer && ['NFHM Reel Analysis QC','NFHM Restoration QC'].includes(selectedSubTask.subTaskName)) {
                await viewStore.getItemDetails({ itemId: NFAIpayload.itemId });
          }
        }
        if (commonStore.NFAIReportCustomer) {
          setTimeout(() => {
            setNFAIReportLoader(false)
            closeTaskFormModal();
            setCancelModelAPI((p) => ({
              ...p,
              isLoading: false,
            }));
          }, 700);
        }
        if (workFlowCommunication.length > 0) {
          workFlowCommunication?.forEach(async (cc) => {
            if (cc.status === statusNumber) {
              await postCommunicationTemp(subTaskIdNo);
              toast.success('Email sent Successfully');
            }
          });
        }
      }, 1000);
      
      if (statusNumber === 7) {
        HistoryPost(
          `resolved SubTask "${selectedSubTask.subTaskName}" to "${getResolvedId.name}" for`,
        );
        // await commonStore.updateHistoryAlonePOST(
        //   `Subtask "${selectedSubTask.subTaskName}" is resolved to "${getResolvedId.name}" by ${user?.displayName}`,
        //   activity?.id,
        // );
      } else if (statusNumber === 5) {
        HistoryPost(
          `rejected SubTask "${selectedSubTask.subTaskName}" due to "${rejectNotify?.reason}" for `,
        );
        if (!SmartTrackerReports) {
          const payload = {
            id: uuid(),
            email: rejectNotify?.email || '',
            email_copy: 'prasaddevnew@gmail.com',
            subject: 'Reject Notification',
            body: rejectNotify?.body || '',
            filename: '',
            model: '',
            status: true,
            dateTime: new Date().toISOString(),
            read: true,
          };
          triggerRejectNotification(payload);
        }
      }
      // if (statusNumber === 5 || statusNumber === 7) {
      //   await viewPageHistory({ itemId: activity?.id, pageNo: 1, pageSize: 4 });
      // }
    }
    
    catch(error) {
      toast.error('Oops ! Something went Wrong.');
      console.log(error);
    };
    if(!commonStore.NFAIReportCustomer){
      closeTaskFormModal(false);
    }
};
  

  // const sendCurrentWorkflowData = async (data: string, statusNo: any) => {
  //   let data2, taskJsonData, taskJsonData2;

  //   if (statusNo === 7) {
  //     // Resolved
  //     let resolveSubTaskId = getResolvedId?.id?.split('|')[0];
  //     let resolveTaskId = getResolvedId?.id?.split('|')[1];
  //     data2 = {
  //       subTaskId: resolveSubTaskId,
  //       isCurrentSubtask: true,
  //     };
  //     taskJsonData = {
  //       taskId: taskId,
  //       status: 'completed',
  //       isCurrentTask: false,
  //     };
  //     taskJsonData2 = {
  //       taskId: resolveTaskId,
  //       status: 'started',
  //       isCurrentTask: true,
  //     };
  //     let params = {
  //       ItemId: id || activity?.id,
  //       CurrentTaskId: taskId,
  //       CurrentSTaskId: subTaskIdNo,
  //       PointedTaskId: resolveTaskId,
  //       PointedSTaskId: resolveSubTaskId,
  //     };
  //     mediaAssetStore.updateResolveSubtask(params);
  //     commonStore.updateHistoryAlonePOST(
  //       `Subtask "${selectedSubTask.subTaskName}" is resolved to "${getResolvedId.name}" by ${user?.displayName}`,
  //       activity?.id,
  //     );
  //     setTimeout(() => {
  //       viewStore.viewPageHistoryAlone({
  //         itemId: activity?.id,
  //         pageNo: 1,
  //         pageSize: 4,
  //       });
  //     }, 200);
  //   } else if (statusNo === 2) {
  //     if (!SmartTrackerReports) {
  //       completeSubtask();
  //     } else {
  //       TrackingReportStore.CurrentSubtaskStatus.status = '';
  //       TrackingReportStore.CurrentSubtaskStatus.value = 0;
  //       TrackingReportStore.currWorkflowModel = false;
  //     }
  //   }
  //   // saveElementChanges("");
  //   selectedSubTask.status = statusNo;
  //   // e.preventDefault();

  //   if (localElementData !== undefined) {
  //     let startDate = '';
  //     let endDate = '';
  //     activityStore.workFlowData?.tasks.forEach((w: any) => {
  //       if (w?.isCurrentTask) {
  //         w.subTasks?.forEach((s: any) => {
  //           if (s?.isCurrentSubtask) {
  //             startDate = s?.startSTDate;
  //             endDate = s?.endSTDate;
  //           }
  //         });
  //       }
  //     });

  //     const subTaskConst = {
  //       autoRejectTo: selectedSubTask.autoRejectTo,
  //       subTaskId: subTaskIdNo,
  //       subTaskName: selectedSubTask.subTaskName,
  //       subTaskDateTime: selectedSubTask.subTaskDateTime,
  //       parallelSubtaskId: selectedSubTask.parallelSubtaskId,
  //       startSTDate: startDate,
  //       endSTDate: endDate,
  //       templateSubtaskId: selectedSubTask.templateSubtaskId,
  //       isActive: selectedSubTask.isActive,
  //       isDeleted: selectedSubTask.isDeleted,
  //       subtaskIndex: selectedSubTask.subtaskIndex,
  //       status: statusNo,
  //       actionerName: user?.displayName,
  //       isCurrentSubtask: statusNo === 2 || statusNo === 7 ? false : true,
  //     };

  //     actionerNameHandler(user?.displayName || '');
  //     const workflowStatus = {
  //       id: activity?.id,
  //       status: data,
  //       current_task: eleModalTitle?.split('/')[1].trim(),
  //       current_subtask: eleModalTitle?.split('/')[2].trim(),
  //       current_user: user?.displayName,
  //     };
  //     let apiUrl = '';
  //     if (activity !== undefined) {
  //       const itemId = activity?.id;
  //       const assetId = activity?.typeid;
  //       const elementId = activity?.elementtypeid;
  //       const tempId = taskData.templateId;
  //       const currTaskId = taskId;
  //       const subTaskId = subTaskIdNo;
  //       let getUrl = '';
  //       currSubTaskData.api.forEach((data: any) => {
  //         if (data.status === statusNo) {
  //           getUrl = data.url;
  //           getUrl = getUrl.replace(/<c [^>]+>Item_Id<\/c>/, itemId);
  //           getUrl = getUrl.replace(/<c [^>]+>Asset_Id<\/c>/, assetId);
  //           getUrl = getUrl.replace(/<c [^>]+>Element_Id<\/c>/, elementId);
  //           getUrl = getUrl.replace(/<c [^>]+>Template_Id<\/c>/, tempId);
  //           getUrl = getUrl.replace(/<c [^>]+>Task_Id<\/c>/, currTaskId);
  //           getUrl = getUrl.replace(/<c [^>]+>SubTask_Id<\/c>/, subTaskId);
  //           apiUrl = getUrl;
  //         }
  //       });
  //     }

  //     if (statusNo !== 2) {
  //       if (CurrentSubtaskStatus.status) {
  //         if (!SmartTrackerReports) {
  //           await ElementStore.updateSubTaskStatus(
  //             subTaskConst,
  //             subTaskIdNo,
  //             data,
  //             workflowStatus,
  //             data2,
  //             apiUrl,
  //             taskJsonData,
  //             taskJsonData2,
  //             activity?.id,
  //             selectedSubTask,
  //             CurrentSubtaskStatus.value,
  //           );
  //         }
  //         TrackingReportStore.CurrentSubtaskStatus.status = '';
  //         TrackingReportStore.CurrentSubtaskStatus.value = 0;
  //         TrackingReportStore.currWorkflowModel = false;
  //         setTimeout(() => {
  //           if (statusNo !== 7) {
  //             TrackingReportStore.currWorkflowModel = true;
  //           } else {
  //           }
  //         }, 1000);
  //       } else {
  //         if (!SmartTrackerReports) {
  //           await ElementStore.updateSubTaskStatus(
  //             subTaskConst,
  //             subTaskIdNo,
  //             data,
  //             workflowStatus,
  //             data2,
  //             apiUrl,
  //             taskJsonData,
  //             taskJsonData2,
  //             activity?.id,
  //             selectedSubTask,
  //           );
  //         }
  //       }
  //     }

  //     // setTimeout(() => {
  //     //   fetchData();
  //     // }, 200);
  //   }
  //   closeTaskFormModal(false);
  // };
  const handleCancelModal = async () => {
    temporaryFilePath?.forEach(async (url: string) => {
      // const splitPath: string[] = url?.split("build") || [];
      await agent.Files.deleteLocalFile(url);
    });
    closeTaskFormModal();
    if (KanbanStore.KanbancompleteTriggerBtn) {
      KanbanStore.loadKanbanData();
    }
    setTemporaryFilePath([]);
    CurrentSubtaskStatus.status = '';
    if (!SmartTrackerReports) {
      dashboardStore.getLocalFilesBasedOnItem(activity?.id);
    }
    // if (currStatus === 0) {
    //   setTimeout(() => {
    //     reportWorflowUpdate();
    //   }, 500);
    // }
    if (SmartTrackerReports) {
      if (smartTrackButtonLabel === '') {
        reportWorflowUpdate();
      } else {
        setSmartTrackButtonLabel?.('');
      }
      statusButtonShow(activity?.status || '');
    }
  };
  const handleDynamicTableManitory = () => {
    let dynamicTableElement = localElementData.filter(
      (element: any) => element.elementType === 'DynamicTable',
    );
    dynamicTableElement = dynamicTableElement?.filter((e:any)=> e.enableByDefault ===  true && e.readOnly === false);
    let toastArr:any[]=[];
    try {
      dynamicTableElement.forEach((element: any) => {
        const parsedData = JSON.parse(element?.elementValue?.split('|')[1] || '[]');
        const isSelectedTrue = element?.options?.filter((obj:any)=> obj.isSelected === true)
        parsedData.forEach((obj: any) => {
          for (const propertyName in obj) {
            if (obj.hasOwnProperty(propertyName) && propertyName !== '_uuid_' && propertyName !== 'Number_of_Frames_Affected' && propertyName !== 'Start Frame') {
              const propertyValue = obj[propertyName];
              isSelectedTrue.forEach((element:any) => {
                if(element.optionName === propertyName) {
                  if (propertyValue === 0 || propertyValue === '' || propertyValue === '0') {
                    toastArr.push(propertyName);
                  }
                }
              });
            }
          }
        });
      });
    } catch (error) {
      console.log(error)
    }
    return [toastArr];
  }
  const nfaiFileIndexHandler = () => {
     const elementNameMap: Record<string, string> = {
          'Encrypted QC Report': 'DCP Encrypted File Upload',
          'Open QC Report': 'DCP Open File Upload',
          'DPX QC Report': 'Ungraded RAWcooked File Upload',
          'DSM QC Report': 'DSM Seamless RAWcooked File Upload',
          'Restoration' : 'Restoration File Upload'
        };

        const elementName = elementNameMap[selectedSubTask.subTaskName];
        const fileIndex = localElementData.findIndex((x: any) => x.elementName === elementName);
        return { fileIndex, elementName};
  }

  const checkSumHandler = async () => {
   try {
     const index = localElementData.findIndex((x:any) => x.elementName === "Check Sum Upload");
     if(index !== -1) {
       const fileUploads: Array<{ fileName: string; url: string; uploadedAt?: string }> = 
          localElementData[index].files || [];

        const latestFile = fileUploads.reduce((latest, current) => {
          // Option A: If you have a proper date field
          // return new Date(current.uploadedAt) > new Date(latest.uploadedAt) ? current : latest;
          
          // Option B: If you must parse from filename, be explicit about the format
          const getDateFromName = (name: string): Date => {
            const match = name.match(/(\d{1,2}\/\d{1,2}\/\d{4}), (\d{1,2}:\d{2}:\d{2} [AP]M)/);
            return match ? new Date(`${match[1]} ${match[2]}`) : new Date(0);
          };
          return getDateFromName(current.fileName) > getDateFromName(latest.fileName) ? current : latest;
        });
       const { data } = await agent.NFAIReport.CheckSumReader(latestFile.url || [], selectedSubTask.subTaskId || "", workflowSubTask.subTaskName === "DPX QC Report" ? '_Restored_RAWcooked.mkv' : '_Restored_DSM_RAWcooked.mkv');
       if(data.includes('Please upload DPX CheckSum values file')){
        toast.error('Please upload DPX CheckSum values file');
       }
       if(data.include('Unable to read file: An invalid request URI was provided. Either the request URI must be an absolute URI or BaseAddress must be set.')) {
        toast.error('Unable to read file: An invalid request URI was provided. Either the request URI must be an absolute URI or BaseAddress must be set.');
       }
     }
   } catch (error) {
    console.log(error);
   }
  }

  
const dcpHandler = async() => {
  try {
           const {fileIndex, elementName } = nfaiFileIndexHandler();
        if (fileIndex !== -1) {
          // Replace 'files' with the actual property name from your data structure
        const fileUploads: Array<{ fileName: string; url: string; uploadedAt?: string }> = 
          localElementData[fileIndex].files || [];

        if (fileUploads.length === 0) {
           setCancelModelAPI((p) => ({
            ...p,
            isLoading: false,
          }));
          toast.error(`Kindly upload ${elementName}`);
          return;
        }

        // If you have an actual timestamp field, use it instead of parsing filename
        const latestFile = fileUploads.reduce((latest, current) => {
          // Option A: If you have a proper date field
          // return new Date(current.uploadedAt) > new Date(latest.uploadedAt) ? current : latest;
          
          // Option B: If you must parse from filename, be explicit about the format
          const getDateFromName = (name: string): Date => {
            const match = name.match(/(\d{1,2}\/\d{1,2}\/\d{4}), (\d{1,2}:\d{2}:\d{2} [AP]M)/);
            return match ? new Date(`${match[1]} ${match[2]}`) : new Date(0);
          };
          return getDateFromName(current.fileName) > getDateFromName(latest.fileName) ? current : latest;
        });
        const subtitles = localElementData.find((x:any) => x.elementName === 'SUBTITLE LANGUAGE')?.elementValue || "";
        const subtaskElementName = workflowSubTask.subTaskName === 'Encrypted QC Report' ? 'DCP (Encrypted) QC Report' : 'DCP (Open) QC Report'
        const qcReport = localElementData?.find((x:any) => x.elementName === subtaskElementName)?.elementValue || "";
        const qcReportElementValue = JSON.parse(qcReport.split('DynamicTable|')[1]);
        const toastData = await agent.NFAIReport.dcpEncrypted(
         latestFile.url,
         activity?.id || '',
         subtitles === "NA" || subtitles === "" ? "No" : "Yes",
         subtaskElementName || "",
         qcReportElementValue
         )
        if (!(toastData as any).includes('DynamicTable|')) {
           toast.error(toastData as any);
          return;
        }
        }
  } catch (error) {
    console.log(error);
  }
}


  const eleFormSubmittion = async (action: string) => {
    setCancelModelAPI((p) => ({
      ...p,
      isLoading: true,
    }));
    if (
        ['Encrypted QC Report', 'Open QC Report', 'DPX QC Report', 'DSM QC Report'].includes(selectedSubTask.subTaskName) &&
        commonStore.NFAIReportCustomer
      ) {
        const {fileIndex, elementName } = nfaiFileIndexHandler();
        if(fileIndex !== -1) {
          const fileUploads: Array<{ fileName: string; url: string; uploadedAt?: string }> = 
          localElementData[fileIndex].files || [];
           if (fileUploads.length === 0) {
           setCancelModelAPI((p) => ({
            ...p,
            isLoading: false,
          }));
          toast.error(`Kindly upload ${elementName}`);
          return;
        }
        }
      }
    setIsSaveClicked(true);
    let containValuesElements = [];
    let isMandatory = false;
    const filterExistDynamicElements = localElementData.filter(
      (el: any) => el.isDynamic,
    );
    const DMReportIndex = filterExistDynamicElements.findIndex(
              (element: any) =>
                element.elementName === "DM Report",
            );
     if (DMReportIndex !== -1) {
      const parsedValue = JSON.parse(
        filterExistDynamicElements[DMReportIndex].elementValue.split("DynamicTable|")[1]
      );
      const excludeKeys = ["Approved By", "Approved By (Employee Id)", "Yes/No"];
      parsedValue.forEach((item: any) => {
        const hasEmptyField = Object.entries(item)
          .filter(([key]) => !excludeKeys.includes(key)) 
          .some(([, value]) => value === "");

        if (hasEmptyField) {
          item["Approved By (Employee Id)"]="";
        }
      });
      filterExistDynamicElements[DMReportIndex].elementValue = `DynamicTable|${JSON.stringify(parsedValue)}`;
    }
    const filterElements = localElementData.filter((el: any) => !el.isDynamic);

    for (let i = 0; i < localElementData.length; i++) {
      const element = localElementData[i];

      if (
        element.elementType.includes('CurrentUser') &&
        element.elementValue === ''
      ) {
        const autoVal = element.elementType.split('|')?.[1];

        switch (autoVal) {
          case 'displayNameWithTimeStamp':
            element.elementValue = `By ${user?.displayName} on ${new Date()}`;
            break;
          case 'timeStamp':
            element.elementValue = new Date().toString();
            break;
          default:
            element.elementValue =
              user?.[autoVal as string as keyof GetCurrentUser];
            break;
        }
      }

      if (element.elementType === 'DatePicker' && element.elementValue === '') {
        element.elementValue = new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
      }

      if (mandatoryFieldsRef.current[element.elementId]) {
        const localErrMsg = {
          ...errorMessage,
          [element.elementId]: 'This is a mandatory field',
        };
        isMandatory = true;
        setErrorMessage(localErrMsg);
      }

      if (
        element.elementType === 'AddPhotograph' ||
        element.elementType === 'AddFiles'
      ) {
        const elementArray = element[element?.elementType];
        const copyArray = copySortedElementData[i]?.[element?.elementType];

        if (elementArray?.length !== copyArray?.length) {
          const payload = {
            id: element.elementId,
            description: element.elementName,
            values: element.elementValue,
            type: element.elementType,
          };
          containValuesElements.push(payload);
        }
      }
      // Other conditions...

      // DynamicTable logic (commented out in the original code)
      else {
        if (element.elementValue !== copySortedElementData[i]?.elementValue) {
          const payload = {
            id: element.elementId,
            description: element.elementName,
            values: element.elementValue,
            type: element.elementType,
          };
          containValuesElements.push(payload);
        }
      }
    }
    if (Object.keys(errorMessage).length > 0) {
      const element = document.getElementById(Object.keys(errorMessage)[0]);
      element?.focus();
      toast.error('Kindly fill appropriate input');
      setCancelModelAPI((p) => ({ ...p, isLoading: false }));
      return;
    }
    const [toastArr] = handleDynamicTableManitory();
    if(user?.customerName !== 'NFAIReport'){
      if (toastArr.length > 0) {
        const uniqueArray = toastArr.filter((item:any, index:any) => toastArr.indexOf(item) === index);
        toast.info(`Please fill ${uniqueArray.join(', ')}`);
        setCancelModelAPI((p) => ({ ...p, isLoading: false }));
        return;
      }
    }
    if(!commonStore.NFAIReportCustomer){
      const filtereddynamicTable = localElementData.filter((element: any) => element.elementType === 'DynamicTable');
     if(filtereddynamicTable.length > 0){  
       let checkAllValueInTable = false;
       filtereddynamicTable.forEach((table:any) => {
         const parsedValue = JSON.parse(table.elementValue.split('|')[1] || '[]');
         if(parsedValue.length > 0){
           const allEmpty = parsedValue.some((table:any) => {
             return Object.keys(table)
                 .filter(key => key !== '_uuid_' && key !== 'newColoumn')
                 .every(key => table[key] === '');
         });
           
         if(allEmpty){
           checkAllValueInTable = true;
         }
         }
       });
       if(checkAllValueInTable){
         toast.error('Kindly fill appropriate table input');
         setCancelModelAPI((p) => ({ ...p, isLoading: false }));
         return;
       }
     }
    }
    
    if(commonStore.NFAIReportCustomer && action === ''){
     if(selectedSubTask.subTaskName === 'Reel Analysis'){
      try {
        await agent.NFAIReport.shotClassification(activity?.id);
      } catch (error) {
        toast.error('Kindly upload appropriate file.');  
        setCancelModelAPI((p) => ({
          ...p,
          isLoading: false,
        }));    
        return;  
      }
     }
     if(selectedSubTask.subTaskName === 'Restoration' && activity?.current_task === 'Final Restoration'){
       await agent.NFAIReport.CutlistAggregation(activity?.id);
     }
    }

    if (isMandatory) {
      toast.error('Kindly fill appropriate input');
      setCancelModelAPI((p) => ({ ...p, isLoading: false }));
      return;
    }


    //------------ history update ------------//
    const shouldUpdateHistory =
      containValuesElements?.length ||
      !localElementData?.length ||
      (action !== '' &&
        !localElementData.some(
          (element: any) =>
            element.isMandatory &&
            !element.elementValue &&
            element.enableByDefault,
        ));
    

    if (shouldUpdateHistory) {
      workflowHistoryHandler(
        containValuesElements,
        removedRow || [],
        addedRow || [],
        dataGridInitialValue,
        dataGridHeaders,
      );
    } else {
      if (!SmartTrackerReports && !commonStore.NFAIReportCustomer) {
        toast.error('Kindly make changes to the item to get it submitted');
        setCancelModelAPI((p) => ({
          ...p,
          isLoading: false,
        }));
        return;
      }
    }

    let subTaskStatus = selectedSubTask.subTaskstatus;

    if (
      selectedSubTask.api.some(
        (apiSettingsAPI: any) => apiSettingsAPI?.status === 8,
      )
    ) {
      subTaskStatus = 8;
    }

    const subTaskConst = {
      ...selectedSubTask,
      actionerName: [1, 8, 4].includes(selectedSubTask.subTaskstatus)
        ? user?.displayName || ''
        : actionerName,
      subTaskId: subTaskIdNo,
      subTaskName: selectedSubTask.subTaskName,
      subTaskDateTime: selectedSubTask.subTaskDateTime,
      templateSubtaskId: selectedSubTask.templateSubtaskId,
      isActive: selectedSubTask.isActive,
      isDeleted: selectedSubTask.isDeleted,
      subtaskIndex: selectedSubTask.subtaskIndex,
      elements: filterElements,
      communication: selectedSubTask.communication,
      api: selectedSubTask.api,
      files: selectedSubTask.files,
      status: subTaskStatus,
      isCurrentSubtask: true,
    };

    uploadFilesSubTask(subTaskConst, subTaskIdNo).then(async () => {
      setCancelModelAPI((p) => ({
        ...p,
        isFormCompleted: true,
        isLoading: false,
      }));
      if(action === ''){
        closeTaskFormModal(true);
      }

      if (user?.customerName === 'NFAI') {
        if (apiSettings.length > 0) {
          await postAPITemp(
            subTaskIdNo,
            activity?.id || '',
            subTaskStatus !== 0 ? subTaskStatus.toString() : null,
          );
        }
        // if (workFlowCommunication.length > 0) {
        //   await postCommunicationTemp(subTaskIdNo);
        // }
      }
    });

    if (ApiStore?.validationstatus === 'Validation applied is matched') {
      toast.success(`${ApiStore?.validationstatus}`);
    } else if (ApiStore?.validationstatus.includes('not matched')) {
      toast.warn(ApiStore?.validationstatus);
    } else {
      if (ApiStore?.validationstatus !== 'Method not allowed') {
        toast.success(`Taskform updated successfully`);
      } else {
        // toast.error('Api validation failed.');
      }
    }

    generatePdfFunction();

    /** --------------- Update dynamic metadata ------------ */
    const listOfDynamicValues = filterExistDynamicElements?.map(
      (data: any) => ({
        id: data.elementId,
        value: isArray(data.elementValue)
          ? data.elementValue?.join('|')
          : data.elementValue,
      }),
    );

    if (listOfDynamicValues.length > 0) {
      await agent.workflowSubtasks.updateElementDetailsAPI(listOfDynamicValues);
      setCancelModelAPI((p) => ({ ...p, isDynamicMetadataCompleted: true }));
    } else {
      setCancelModelAPI((p) => ({ ...p, isLoading: false }));
    }

    //-------------- Kanban API -----------------//
    if (KanbanStore?.KanbancompleteTriggerBtn) {
      setTimeout(() => {
        KanbanStore.loadKanbanData();
      }, 250);
    }
    if (SmartTrackerReports) {
      switch (smartTrackButtonLabel) {
        case 'Start':
          await startProject();
          break;
        case 'Hold':
          await openHold();
          break;
        case 'Resume':
          await openResume();
          break;
        case 'Reject':
          await rejectSubmitHandler('', '', '');
          break;
        case 'Completed':
          await openCompleted();
          break;
      }
      if (smartTrackButtonLabel !== '') {
        setSmartTrackButtonLabel?.('');
        statusButtonShow('');
      }
    }
    if (action === 'completeTask') {
      setTimeout(() => {
        isFinishCheck()
      }, 250);
    }
    if(commonStore.NFAIReportCustomer && selectedSubTask.subTaskName === 'Restoration' && activity?.current_task.includes('Final Restoration')){
      await agent.NFAIReport.ImageRestorationSort(activity?.id);
     
  }
    if(metaDataStore.masteringFileUpload) {
     metaDataStore.masteringFileUpload = false;
      if(commonStore.NFAIReportCustomer && selectedSubTask.subTaskName === 'Restoration' && activity?.current_task.includes('Final Restoration')) {
         const imageRestorationIndex = localElementData.findIndex((x:any) => x.elementName === 'Image Restoration');
      const NFAI_QC_Restoration_Supervisor_FeedIndex = localElementData.findIndex((x:any) => x.elementName === 'NFHM QC Restoration Supervisor Feedback')
       const {fileIndex,  } = nfaiFileIndexHandler();
        if (fileIndex !== -1) {
          // Replace 'files' with the actual property name from your data structure
        const fileUploads: Array<{ fileName: string; url: string; uploadedAt?: string }> = 
          localElementData[fileIndex].files || [];

           const latestFile = fileUploads.reduce((latest, current) => {
          // Option A: If you have a proper date field
          // return new Date(current.uploadedAt) > new Date(latest.uploadedAt) ? current : latest;
          
          // Option B: If you must parse from filename, be explicit about the format
          const getDateFromName = (name: string): Date => {
            const match = name.match(/(\d{1,2}\/\d{1,2}\/\d{4}), (\d{1,2}:\d{2}:\d{2} [AP]M)/);
            return match ? new Date(`${match[1]} ${match[2]}`) : new Date(0);
          };
          return getDateFromName(current.fileName) > getDateFromName(latest.fileName) ? current : latest;
        });

      await agent.NFAIReport.Restoration_File_upload(latestFile?.url || "", localElementData[imageRestorationIndex].elementId , localElementData[NFAI_QC_Restoration_Supervisor_FeedIndex].elementId, activityStore?.selectedActivity?.id || "");
    }
      }
        if (
        ['DPX QC Report', 'DSM QC Report'].includes(selectedSubTask.subTaskName) &&
        commonStore.NFAIReportCustomer
      ) {
       const {fileIndex, elementName } = nfaiFileIndexHandler();
        if (fileIndex !== -1) {
          // Replace 'files' with the actual property name from your data structure
        const fileUploads: Array<{ fileName: string; url: string; uploadedAt?: string }> = 
          localElementData[fileIndex].files || [];

        if (fileUploads.length === 0) {
           setCancelModelAPI((p) => ({
            ...p,
            isLoading: false,
          }));
          toast.error(`Kindly upload ${elementName}`);
          return;
        }

        // If you have an actual timestamp field, use it instead of parsing filename
        const latestFile = fileUploads.reduce((latest, current) => {
          // Option A: If you have a proper date field
          // return new Date(current.uploadedAt) > new Date(latest.uploadedAt) ? current : latest;
          
          // Option B: If you must parse from filename, be explicit about the format
          const getDateFromName = (name: string): Date => {
            const match = name.match(/(\d{1,2}\/\d{1,2}\/\d{4}), (\d{1,2}:\d{2}:\d{2} [AP]M)/);
            return match ? new Date(`${match[1]} ${match[2]}`) : new Date(0);
          };
          return getDateFromName(current.fileName) > getDateFromName(latest.fileName) ? current : latest;
        });

        const toastData = await masteringStore.MasteringFileUploadHandler(
          selectedSubTask.subTaskName,
          selectedSubTask.subTaskId || '',
          latestFile.url
        );
        if(toastData?.length < 0 || !toastData) {
          toast.error(toastData);
          setCancelModelAPI((p) => ({
            ...p,
            isLoading: false,
          }));  
          return;
        }
        }
      }
        if(['DPX QC Report', 'DSM QC Report'].includes(selectedSubTask?.subTaskName)) {
          checkSumHandler();
        } 
        if (selectedSubTask.subTaskName === "Deliverables QC Report" && commonStore.NFAIReportCustomer) { 
          setTimeout(() => {
            deliveriableHandler();
          }, 1500);
      }
      if(['Encrypted QC Report', 'Open QC Report'].includes(selectedSubTask?.subTaskName)) {
          dcpHandler();
      }
    }
  };
  
const deliveriableHandler = async() => {
  try {
    const fileElements = localElementData.filter((element:any) => 
      element.elementType === 'AddFiles' && element.files.length > 0
    );

    const extractTimestamp = (fileName: string): Date => {
      const match = fileName.match(/(\d{1,2}\/\d{1,2}\/\d{4},\s\d{1,2}:\d{2}:\d{2}\s[AP]M)/);
      return match ? new Date(match[1]) : new Date(0);
    };

    const elementIndexMap: any = {
      'ProRes UHD File Upload': 0,
      'ProRes FHD File Upload': 1,
      'MP4 File Upload': 2,
      'MP4 watermark File Upload': 3,

      // checksum 
      'ProRes UHD Check Sum Upload': 0,
      'ProRes FHD Check Sum Upload': 1,
      'MP4 Check Sum Upload': 2,
      'MP4 watermark Check Sum Upload': 3,
    };
    

    const apiCallsData:any[] = [];


    fileElements.forEach((element:any, index:number) => {
    const mostRecentFile = element.files.reduce((latest:any, current:any) => {
            const latestTime = extractTimestamp(latest.fileName);
            const currentTime = extractTimestamp(current.fileName);
            return currentTime > latestTime ? current : latest;
          });

          const apiIndex = elementIndexMap[element.elementName];
          if (apiIndex === undefined) {
            console.error(`Unknown element name: ${element.elementName}`);
            return;
          }

          apiCallsData.push({
            index,
            elementName: element.elementName.includes('Check Sum') ? 'Check Sum File Upload' : 'File Upload',
            apiIndex,
            mostRecentFileUrl: mostRecentFile.url
          });
    });

    // Sort by apiIndex to ensure correct order (0, 1, 2, 3)
    apiCallsData.sort((a, b) => a.index - b.index);

    const subtitles = localElementData.find((x:any) => x.elementName === 'subtitles available');
    
    // Initialize QC report data for first call only
    let currentQCReport = [];
    const initialQcReportValue = localElementData?.find((x:any) => x.elementName === 'QC REPORT')?.elementValue || "";
    if (currentQCReport.length === 0) {
      const parsedValue = JSON.parse(initialQcReportValue.split('DynamicTable|')[1]);
      currentQCReport = normalizeDeliverablesQcRows(parsedValue).map((x:any) => ({...x, QC_File_Format: x.qC_File_Format ?? x.QC_File_Format ?? ""}));
    }
    
    for (let i = 0; i < apiCallsData.length; i++) {
       //eslint-disable-next-line
      const { _, elementName, apiIndex, mostRecentFileUrl } = apiCallsData[i];
      
      // First call uses initial QC report, others use empty or previous response
      
      const response = elementName.includes('Check Sum') ? await agent.NFAIReport.DeliverableCheckSumReader(
        apiIndex,
        workflowSubTask.subTaskId || "",
        mostRecentFileUrl, 
        currentQCReport
      ) :  await agent.NFAIReport.deliverables(
        apiIndex,
        subtitles?.elementValue || "No",
        workflowSubTask.subTaskId || "",
        mostRecentFileUrl, 
        currentQCReport
      );
      
      // Update currentQCReport with response data for next iteration
      // Adjust this based on your actual response structure
      if (response && response.data) {
        currentQCReport = normalizeDeliverablesQcRows(
          JSON.parse(response.data.split('DynamicTable|')[1])
        );
        }
      
    }
    
    console.log('All deliverable API calls completed successfully');
    
  } catch (error) {
    console.error('Error in deliveriableHandler:', error);
    throw error;
  }
}

  const onConfirmUser = async (validationData: any) => {
    let copyElements = [...copySortedElementData];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    // let previousValue = copyElements[indexOfData]?.elementValue || '';
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: user?.displayName,
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    if (validationData?.isMandatory) {
      result = 'This is mandatory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }
    setErrorMessage(errorTemp);
    setCopySortedElementData(copyElements);
  };

  const rejectSubmitHandler = async (
    email: string,
    body: string,
    reason: string,
  ) => {
    await sendCurrentWorkflowData('Rejected', 5, {
      email,
      body,
      reason,
    });
    mediaAssetStore.mediaAsset.alertsResolveorRejectModalOpen = false;
    if (CurrentSubtaskStatus.status) {
      // statusChanger(
      //   activity?.id,
      //   TrackingReportStore.CurrentSubtaskStatus.value,
      // );
      CurrentSubtaskStatus.status = '';
      CurrentSubtaskStatus.value = 0;
      // reportWorflowUpdate();
      // setShowTasksModal(true)
      // setTimeout(() => {
      //   TrackingReportStore.currWorkflowModel = false;
      // }, 1000);
      return;
    }
    closeTaskFormModal();
    setIsRejectModalOpened(false);
    mediaAssetStore.openMediaAssetRejectModal(false);
  };
  const buttonName =
  user?.customerName === 'NFAIReport' &&
  (taskname === 'Color Grading' && selectedSubTask.subTaskName === 'NFHM Color Grading QC' ? 'ColorGradingReport' :
   taskname === 'Data Management' && selectedSubTask.subTaskName === 'Data Management' ? 'Data_Management' :
   taskname === 'Base Grade' && selectedSubTask.subTaskName === 'Base Grade' ? 'Base_Grade_Report' :
   taskname === 'AV Sync' && selectedSubTask.subTaskName === 'AV Sync' ? 'AV_Sync' :
   taskname === 'Color Grading' && selectedSubTask.subTaskName === 'NFHM Reel Analysis QC' ? 'NFHM_Reel_Analysis_QC' :
   taskname === 'Color Grading' && selectedSubTask.subTaskName === 'NFHM Restoration QC' ? 'NFHM_Restoration_QC' :
   taskname === 'Deliverables' && selectedSubTask.subTaskName === 'Deliverables QC Report' ? 'Deliverables_QC_Report' :
   taskname === 'LTO' && selectedSubTask.subTaskName === 'LTO QC Report' ? 'LTO_QC_Report' :
   taskname === 'LTO' && selectedSubTask.subTaskName === 'LTO Label Creation' ? 'LTO_Label' :
   taskname === "FFV1" && selectedSubTask.subTaskName === "DPX QC Report" ? "DPX_QC_Report" :
   taskname === "FFV1" && selectedSubTask.subTaskName === "DSM QC Report" ? "DSM_QC_Report" :
   taskname === "DCP" && selectedSubTask.subTaskName === "Encrypted QC Report" ? "Encrypted_QC_Report" :
   taskname === "DCP" && selectedSubTask.subTaskName === "Open QC Report" ? "Open_QC_Report" :
   taskname === "LTO" && selectedSubTask.subTaskName === "Consolidated Restoration Report and Quality Sign Off" ? "Consolidated_Restoration_Report_and_Quality_Sign_Off" :
   null);

  const headerRender = () => {
    const hiddenSubTasks = [
      'Deliverables QC Report',
      'LTO QC Report',
      'LTO Label Creation',
      'DPX QC Report',
      'DSM QC Report',
      'Encrypted QC Report',
      'Open QC Report'
    ];
    return (
      <>
        {(commonStore.NFAIReportCustomer ? (!(nFAIReportLoader || isLoading || workflowSubTaskLoader || !hasElements) && selectedSubTask?.isCurrentSubtask) : selectedSubTask?.isCurrentSubtask) &&
          (kanbanTiggerbutton !== true && selectedSubTask.isFinish ? (
            <Button.Group floated="right">
              <Button color="blue" floated="right" onClick={openCompleted}>
                Finish
              </Button>
            </Button.Group>
          ) : (
            <>
              {currStatus === 3 && kanbanTiggerbutton !== true && (
                <Button floated="right" onClick={openResume}>
                  Resume
                </Button>
              )}
              {currStatus === 5 && kanbanTiggerbutton !== true && (
                <Button floated="right" onClick={openResolve} color="green">
                  Resolve
                </Button>
              )}
              {user?.displayName === actionerName &&
                (currStatus === 1 || currStatus === 8 || currStatus === 4) &&
                kanbanTiggerbutton !== true && (
                  <Button.Group floated="right">
                    {buttonName ? <>{buttonRender(buttonName)}</> :
                     (
                      <Button
                        color="blue"
                        floated="right" 
                        onClick={openCompleted}
                      >
                        {selectedSubTask.subTaskName === 'Client QC'
                          ? 'Approve'
                          : 'Complete'}
                      </Button>
                    )}
                    { hiddenSubTasks.includes(selectedSubTask.subTaskName) ? null : <Button.Or /> }
                    <Button color="yellow" floated="right" onClick={openHold}>
                      Hold
                    </Button>
                    {user?.customerName !== 'NFAIReport' && 
                    <>
                    <Button.Or />
                    <Button color="red" floated="right" onClick={openReject}>
                      Reject
                    </Button>
                    </>
                    }
                  </Button.Group>
                )}
              {selectedSubTask?.isCurrentSubtask &&
                currStatus === 0 &&
                kanbanTiggerbutton !== true && (
                  <Button floated="right" color="blue" onClick={startProject}>
                    Start
                  </Button>
                )}
            </>
          ))}
        <div className="w-500">
        <span style={{ margin: 0 }}>
            {(activity?.title || '') + eleModalTitle ||
              ' /' + activity?.current_task + ' /' + activity?.current_subtask}
          </span>
        </div>
      </>
    );
  };

  const formRender = () => {
    return (
      <Form
        style={{
          position: 'relative',
          width: '100%',
          margin: '20px auto',
        }}
      >
        <Form.Group widths="equal" className="workflowModalComponentsWrapper">
          {(commonStore.NFAIReportCustomer ? (nFAIReportLoader || isLoading || workflowSubTaskLoader || !hasElements) : ((isLoading || nFAIReportLoader || workflowSubTaskLoader) || !hasElements))  ? (
            <LoadingComponent />
          ) : (!hasElements)? (
            <span
              style={{
                color: 'grey',
                fontSize: '17px',
                padding: '0 0 0 20px',
                fontWeight: 700,
              }}
            >
              Sorry, No data
            </span>
          ) : (
            localElementData
            ?.sort((a:any, b:any) => a.elementIndex - b.elementIndex)
            ?.map((elem: any, index: number) => {
              return (
                !commonStore.filterModeTwo?.includes(
                  elem.templateElementId,
                ) && (
                  <>
                    <Components
                      disabled={commonStore.filterModeZero?.includes(
                        elem.templateElementId,
                      )}
                      index={index}
                      templateId={activeOrder.templateId || ''}
                      elementDetails={elem}
                      addPhotographsHandler={() =>
                        dashboardStore.setOpenCameraModal(true)
                      }
                      onChangeHandler={onChangeHandler}
                      saveDynamicTableData={saveDynamicTableData}
                      camImage={camImage}
                      // classNameFunc={classNameFunc}
                      masterOptions={
                        (elem.elementType === 'Masters' &&
                          mastersList[
                            `${
                              elem.elementValue?.toString()?.split('|')?.[0] ||
                              ''
                            }`
                          ]) ||
                        []
                      }
                      usersOptions={
                        (elem.elementType === 'Users' &&
                          userList[
                            `${
                              elem.elementValue?.toString()?.split('|')?.[0] ||
                              ''
                            }`
                          ]) ||
                        []
                      }
                      errorMessage={isSaveClicked ? errorMessage : ''}
                      mastersHandler={(e: SyntheticEvent, data: any) =>
                        mastersAndUsersHandler(e, data)
                      }
                      usersHandler={(e: SyntheticEvent, data: any) =>
                        mastersAndUsersHandler(e, data)
                      }
                      onPhotoClick={() => onPhotoClick(index)}
                      getUploadedFiles={getUploadedFiles}
                      subTaskIdNo={subTaskIdNo}
                      RoleChecker={false}
                      onConfirmUser={onConfirmUser}
                      subTaskName={selectedSubTask.subTaskName}
                      allElementsData={localElementData}
                    />
                  </>
                )
              );
            })
          )}
        </Form.Group>
      </Form>
    );
  };

  const addToItemFiles = async (blobFile: Blob, fileName: string,iscomplete:boolean) => {
    let response;
    let addFilesPayload: uploadFileType = { id: '', files: [] };
    var file = new File([blobFile], fileName);
    if (commonStore.devEnv && !SmartTrackerReports) {
      const item = activity?.id;
      const workLevel = dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
      response = await agent.Files.localFileUpload(file, workLevel, item);
      const url = response.data.path.replace(/\\\\/g, '\\');
      const filename = url.substring(url.lastIndexOf('\\') + 1);
      addFilesPayload = {
        id: activity?.id,
        files: [
          {
            id: uuid(),
            fileId: response.data.id,
            fileName: filename,
            url: url,
            addedOn: new Date(),
          },
        ],
      };
      dashboardStore.getLocalFilesBasedOnItem(item);
    } else {
      response = await agent.Files.uploadFile(file);
      addFilesPayload = {
        id: activity?.id,
        files: [{ ...response.data, addedOn: new Date() }],
      };
    }
    await generatePdf(addFilesPayload);
    if(!iscomplete){
      closeTaskFormModal();
    } 
  };
  const getDocument = (isDualPDF:boolean) => {
    if(taskname === 'Data Management'){
      // eslint-disable-next-line
    return  <DM_And_BaseGrading_Reports name='DM Report' isDualPDF={isDualPDF}/>
    }
    else if(taskname === 'Base Grade'){
      // eslint-disable-next-line
      return <DM_And_BaseGrading_Reports name='Grading Report' isDualPDF={isDualPDF}/> 
    }
    else if (taskname === 'Final Restoration' || taskname === 'Color Grading') {
      if (selectedSubTask.subTaskName === 'NFHM Reel Analysis QC'  || selectedSubTask.subTaskName === 'Reel Analysis') {
        return <NFAIReelAnalysisReport modalTitleDetails={eleModalTitle} isDualPDF={isDualPDF}/>;
      } else if (selectedSubTask.subTaskName === 'NFHM Restoration QC' || selectedSubTask.subTaskName === 'Restoration') {
        return <NFAIRestorationReport isDualPDF={isDualPDF}/>;
      }
      else if (selectedSubTask.subTaskName === 'NFHM Color Grading QC') {
        return <ColorGradingReport isDualPDF={isDualPDF}/>;
      }
    } else if (
      taskname === 'Final Grade' &&
      selectedSubTask.subTaskName === 'NFHM Grading QC'
    ) {
      return <GradingQC />;
    } else if (
      taskname === 'AV Sync' &&
      selectedSubTask.subTaskName === 'AV Sync'
    ) {
      return <AudioSyncReport />;
    } else if (
      taskname.trim() === 'Deliverables' && 
      selectedSubTask.subTaskName.trim() === 'Deliverables QC Report'
    ) {
      return <DeliverablesReport localElement={localElementData} metadata={metadata} isDualPDF={isDualPDF} />
    } else if (taskname.trim() === 'LTO') {
        if(selectedSubTask.subTaskName.trim() === "LTO QC Report"){ 
          return <LTOReport localElementData={localElementData} isDualPDF={isDualPDF} />
        } else {
           return <LTOLabelGeneration localElement={localElementData} metadata={metadata} />
        }
      // return <QualityCheckReport metadata={metadata}/>
    } else if(taskname.trim() === "FFV1") { 
        if(selectedSubTask.subTaskName.trim() === "DPX QC Report"){ 
         return<FFV1ReportsPDF name ={selectedSubTask.subTaskName} localElement={localElementData} metadata={metadata}  subtaskId={selectedSubTask.subTaskId} isDualPDF={isDualPDF} />
        } else {
           return <FFV1ReportsPDF name ={selectedSubTask.subTaskName} localElement={localElementData} metadata={metadata} subtaskId={selectedSubTask.subTaskId} isDualPDF={isDualPDF} />
        }
    }
    else if(taskname.trim() === "DCP") { 
        if(selectedSubTask.subTaskName.trim() === "Open QC Report"){ 
            return <DCPEncryptedOpenReport name ={selectedSubTask.subTaskName} localElement={localElementData} metadata={metadata} subtaskId={selectedSubTask.subTaskId} isDualPDF={isDualPDF} />
        } else {
            return  <DCPEncryptedOpenReport name ={selectedSubTask.subTaskName} localElement={localElementData} metadata={metadata} subtaskId={selectedSubTask.subTaskId} isDualPDF={isDualPDF} />
        }
    }
    else if(taskname?.trim() === "Consolidated Restoration Report and Quality Sign Off" && selectedSubTask.subTaskName?.trim() === "Consolidated Restoration Report and Quality Sign Off") { 
      return <ConsolidatedReport subtaskId={selectedSubTask.subTaskId} isDualPDF={isDualPDF}/>
    }
    return <></>;
  };

  const getFileName = () => {
    const uccId = metadata.findIndex((e)=> e.elementName === 'UCCID')
    // const movieName = activity?.title.split('-')[1].trim();
    const movieName = metadata?.find((e)=> e.elementName === 'Film_Title')?.elementValue?.trim() || '';
    let titleName = '';
    if(uccId !== -1 && movieName){
      titleName = `${metadata[uccId].elementValue}_${movieName}_`
    }
    if(taskname === 'Data Management'){
      return `${titleName}Data_Management_Report.pdf`
    }
    else if(taskname ==='Base Grade')
      {
        return `${titleName}Base_Grade_Report.pdf`
      }
    else if (taskname === 'Final Restoration' || taskname === 'Color Grading') {
      if (selectedSubTask.subTaskName === 'NFHM Reel Analysis QC' || selectedSubTask.subTaskName === 'Reel Analysis') {
        return `01_${titleName}Reel_Analysis_Report.pdf`;
      } else if (selectedSubTask.subTaskName === 'NFHM Restoration QC' || selectedSubTask.subTaskName === 'Restoration') {
        return `03_${titleName}Restoration_Report.pdf`;
      }
      else if(selectedSubTask.subTaskName === 'NFHM Color Grading QC'){
        return `04_${titleName}Color_Grading_Report.pdf`;
      }
    } else if (
      taskname === 'Final Grade' &&
      selectedSubTask.subTaskName === 'NFHM Grading QC'
    ) {
      return `${titleName}NFHM_Grading_QC_Report.pdf`;
    } else if (
      taskname === 'AV Sync' &&
      selectedSubTask.subTaskName === 'AV Sync'
    ) {
      return `${titleName}Audio_Sync_Report.pdf`;
    } else if (
      taskname === 'Deliverables' && 
      selectedSubTask.subTaskName === 'Deliverables QC Report'
    ) {
      return `07_${titleName}Deliverables_QC_Report.pdf`;
    } else if (
      taskname === 'LTO' && 
      selectedSubTask.subTaskName === 'LTO QC Report'
    ) {
      return `10_${titleName}LTO_QC_Report.pdf`;
    } else if (
      taskname === 'LTO' && 
      selectedSubTask.subTaskName === 'LTO Label Creation'
    ) {
      return `${titleName}LTO_Label.pdf`;
    } else if (
      taskname.trim() === 'FFV1' &&
      selectedSubTask.subTaskName.trim() === 'DPX QC Report'
    ) {
      return `08_${titleName}FFV1_DPXs_QC_Report.pdf`;
    } else if (
      taskname.trim() === 'FFV1' &&
      selectedSubTask.subTaskName.trim() === 'DSM QC Report'
    ) {
      return `09_${titleName}FFV1_DSM_QC_Report.pdf`;
    }
    else if (
      taskname.trim() === 'DCP' &&
      selectedSubTask.subTaskName.trim() === 'Encrypted QC Report'
    ) {
      return `05_${titleName}DCP_Encrypted_QC_Report.pdf`;
    } else if (
      taskname.trim() === 'DCP' &&
      selectedSubTask.subTaskName.trim() === 'Open QC Report'
    ) {
      return `06_${titleName}DCP_Open_QC_Report.pdf`;
    }
    else if(selectedSubTask.subTaskName?.trim() === "Consolidated Restoration Report and Quality Sign Off") {
      return  `11_${titleName}ConsolRest_Report.pdf`;
    }
    return '';
  };

  const NFIARestotoast = () => {
    let condtionArr:any[] = [];
    if(user?.customerName === 'NFAIReport'){
        (selectedSubTask.subTaskName === 'AV Sync' ?
         AVSyncValidation : selectedSubTask.subTaskName === 'NFHM Reel Analysis QC' ?
          Reel_AnaylsisValidation  : selectedSubTask.subTaskName === 'NFHM Restoration QC' ? 
          Restoration_Validation : selectedSubTask.subTaskName === 'NFHM Color Grading QC' ? colorGradingvalidation : BaseGrade_DM_metadata).forEach(element => {
          metadata.forEach(meta => {
            if (meta.elementName === element) {
              if(meta?.elementValue?.includes('|') && meta.elementValue.split('|')[1] === ''){
                condtionArr.push(meta.elementName);
              }
              else if ((meta.elementValue === "" || meta.elementValue === '0') && !meta.elementValue.includes('|')) {
                condtionArr.push(meta.elementName)
              }
            }
          });
        });
    }
    return condtionArr;
}

const handleGenerateAndDownload = async () => {
    try {
      // 1️⃣ Generate the PDF blob on the fly
      const blob = await pdf(getDocument(true)).toBlob();
 
      // 2️⃣ Create a download link element dynamically
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = getFileName();
      document.body.appendChild(link);
 
      // 3️⃣ Trigger the download
      link.click();
 
      // 4️⃣ Optional: Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
 
      // 5️⃣ Run your custom logic
      await addToItemFiles(blob, getFileName(), false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const buttonRender = (value: string) => {
    const isReportDownload =
      commonStore.NFAIReportCustomer &&
      ( value === 'ColorGradingReport' ||
        value === 'Data_Management' ||
        value === 'Base_Grade_Report' ||
        value === 'AV_Sync' ||
        value === 'NFHM_Reel_Analysis_QC' ||
        value === 'NFHM_Restoration_QC' ||
        value === 'Deliverables_QC_Report' ||
        value === 'LTO_QC_Report' ||
        value === 'LTO_Label' ||
        value === "DPX_QC_Report" ||
        value === "DSM_QC_Report" ||
        value === 'Encrypted_QC_Report' ||
        value === 'Open_QC_Report' ||
        value === "Consolidated_Restoration_Report_and_Quality_Sign_Off"
      );
      // const isApprovalCheck = NFAIRestoApprovallCheck();
      const condtionArr = NFIARestotoast();
      const [toastArr] = handleDynamicTableManitory();
      const hiddenSubTasks = [
        'Deliverables QC Report',
        'LTO QC Report',
        'LTO Label Creation',
        'DPX QC Report',
        'DSM QC Report',
        'Encrypted QC Report',
        'Open QC Report',
        'Consolidated Restoration Report and Quality Sign Off'
      ];

      const shouldHideCompleteButton =
        isReportDownload &&
        hiddenSubTasks.includes(selectedSubTask?.subTaskName);

    return (
      <>
          {user?.customerName === 'NFAIReport' &&
            ['Data Management','Base Grade','Final Restoration', 'Color Grading', 'Final Grade', 'AV Sync', 'Deliverables', 'LTO',"FFV1", "DCP", "Consolidated Restoration Report and Quality Sign Off"].includes(taskname) &&
            [
              'Data Management',
              'Base Grade',
              'Reel Analysis',
              'Restoration',
              'NFHM Reel Analysis QC',
              'NFHM Restoration QC',
              'NFHM Color Grading QC',
              'AV Sync',
              'Deliverables QC Report',
              'LTO QC Report',
              'LTO Label Creation',
              "DPX QC Report",
              "DSM QC Report",
              "Encrypted QC Report",
              "Open QC Report",
              "Consolidated Restoration Report and Quality Sign Off"
            ].includes(selectedSubTask.subTaskName) &&
            !shouldHideCompleteButton && (
              ((condtionArr.length > 0 || toastArr.length > 0) && value !== '') ? (
                <Button
                  style={isReportDownload
                    ? { backgroundColor: '#2185d0', color: '#fff' }
                    : { backgroundColor: 'lightgrey', color: 'black', float:'left' }} 
                  onClick={() => {
                    if (toastArr.length > 0) {
                      const uniqueArray = toastArr.filter((item:any, index:any) => toastArr.indexOf(item) === index);
                      toast.info(`Please fill ${uniqueArray.join(', ')}`);
                    }
                    if (condtionArr.length > 0) {
                      const uniqueArray1 = condtionArr.filter((item:any, index:any) => condtionArr.indexOf(item) === index);
                      toast.info(` Kindly fill in the metadata - ${uniqueArray1} to generate the report.`);
                    }
                  }}
                >
                  {isReportDownload ? 'Complete' : 'Generate Report'}
                </Button>
              ) : isNFAITableCheck !== '' && value !== '' ? (
                <Button
                  style={isReportDownload
                    ? { backgroundColor: '#2185d0', color: '#fff' }
                    : { backgroundColor: 'lightgrey', color: 'black', float:'left' }} 
                  onClick={() => {
                    if (isNFAITableCheck !== '') {
                      toast.info(isNFAITableCheck);
                      return;
                    }
                  }}
                >
                  {isReportDownload ? 'Complete' : 'Generate Report'}
                </Button>
              ) : (
                <PDFDownloadLink  
                  document={getDocument(false)}
                  fileName={getFileName()}
                  className="genRep"
                >
                  {({ blob, url, loading, error }) =>
                    loading ? (
                      <Button>Loading document...</Button>
                    ) : (
                      <Button
                        onClick={() => {
                          handleGenerateAndDownload();
                          addToItemFiles(blob!, getFileName(), isReportDownload);
                          isReportDownload && setTimeout(openCompleted, 250);
                        }}
                        style={
                          isReportDownload
                            ? { backgroundColor: '#2185d0', color: '#fff' }
                            : {}
                        }
                      >
                        {isReportDownload ? 'Complete' : 'Generate Report'}
                </Button>
                    )
                  }
                </PDFDownloadLink>
              )
          )}

          {(commonStore.NFAIReportCustomer && activity?.title.includes('Cutlist') && 
          (selectedSubTask?.subTaskName === 'Restoration' || selectedSubTask?.subTaskName === 'QC' || selectedSubTask?.subTaskName === 'Quality Check') && 
          !(nFAIReportLoader || isLoading || workflowSubTaskLoader 
            || !hasElements)) && (
              <Button 
              style={isReportDownload ? { backgroundColor: '#2185d0', color: '#fff' } : { backgroundColor: 'lightgrey', color: 'black',float:'left' }}
              onClick={async () =>{
                // await HandleCutlistReelAnaylsis(itemDetails.parent?.split('/')[0] || '');
                // if(viewStore?.NFAIReportCutlistCheck){
                //   toast.info('Reel Analysis file has to upload to start cutlist ');
                //   return;
                // }
                const reelNo = activity?.title?.split('Reel')?.[1]?.split('-')?.[0]?.trim()
                const startFrame = metadata.filter((m) => m.elementName === 'Start Frame')[0]?.elementValue
                const endFrame = metadata.filter((m) => m.elementName === 'End Frame')[0]?.elementValue
                await reportStore.HandleCutlistPreivew(activity?.id,reelNo,parseInt(startFrame),parseInt(endFrame));
                setViewShotsModel(true)
              }}>
               View Shots
              </Button>
            )}
        {/* <Grid>
          <Grid.Row>
            {assignedUsers?.map((attendee) => (
              <Popup
                hoverable
                key={attendee.id}
                trigger={
                  <List.Item
                    key={attendee.displayname}
                    // as={Link}
                    // to={`/profiles/${attendee.displayname}`}
                  >
                    <Image
                      size="mini"
                      circular
                      src={attendee.image || '/assets/user.png'}
                      style={{
                        marginLeft: '20px',
                      }}
                    />
                  </List.Item>
                }
              >
                <PopupContent>
                  <ProfileCard
                    images={attendee.image}
                    displayname={attendee?.displayname}
                  />
                </PopupContent>
              </Popup>
            ))}
          </Grid.Row>
        </Grid> */}
        {!isReportDownload && (
          <Button.Group>
            <Button
              disabled={cancelModelAPI.isLoading}
              onClick={handleCancelModal}
            >
              Cancel
            </Button>
            <Button.Or />
            <Button
              loading={cancelModelAPI.isLoading}
              disabled={cancelModelAPI.isLoading}
              className={
                SmartTrackerReports
                  ? ''
                  : selectedSubTask.isCurrentSubtask &&
                      (selectedSubTask.isFinish ||
                        ((selectedSubTask.subTaskstatus === 1 ||
                          selectedSubTask.subTaskstatus === 8 ||
                          selectedSubTask.subTaskstatus === 4) &&
                          actionerName === user?.displayName))
                    ? ''
                    : 'ele-disable-submitBtn'
              }
              positive
              onClick={() => eleFormSubmittion('')}
            >
              {user?.customerName === 'NFAIReport' ? 'Save' : 'Submit'}
            </Button>
          </Button.Group>
        )}
      </>
    );
  };

  return (
    <>
    {commonStore.NFAIReportCustomer && viewShotsModel 
    && <CutlistPreviewModal 
    CutlistDetails={reportStore.NFAIReportCutlistPreviewList}
    viewShotsModel={viewShotsModel} 
    setviewShotsModel={setViewShotsModel}/>}
    
      {dashboardStore.dashboard.openCameraModal ? (
        <CamModal getUploadedPhotos={getUploadedPhotos} index={photoIndex} />
      ) : null}
      {isRejectModalOpened && (
        <AlertsResolveorRejectModal
          closeHandler={() => {
            setIsRejectModalOpened(false);
          }}
          handleFormSubmit={(email, body, value) => {
            rejectSubmitHandler(email, body, value);
          }}
          subTaskName={selectedSubTask.subTaskName}
        />
      )}
      {isResolveModalOpened ? (
        <MediaAssetResolveModal
          selectedSubTaskId={subTaskIdNo}
          closeHandler={() => {
            setTimeout(() => {
              reportWorflowUpdate();
            }, 500);
            setCurrStatus(5);
            setIsResolveModalOpened(false);
          }}
          submitHandler={() => {
            setIsResolveModalOpened(false);
          }}
        />
      ) : null}
      {withoutModal ? (
        <div className="workflow-without-modal-wrapper">
          <p
            style={{
              fontSize: '1.42857143rem',
              lineHeight: '1.28571429em',
              fontWeight: '700',
            }}
          >
            {headerRender()}
          </p>
          <div
            style={{
              minHeight: '100px',
              maxHeight: '70vh',
              overflowY: 'auto',
              padding: '0px',
              borderTop: '1px solid #e3e3e3',
            }}
            className={
              selectedSubTask.isCurrentSubtask &&
              (selectedSubTask.isFinish ||
                ((selectedSubTask.subTaskstatus === 1 ||
                  selectedSubTask.subTaskstatus === 8 ||
                  selectedSubTask.subTaskstatus === 4) &&
                  actionerName === user?.displayName))
                ? ''
                : 'ele-disable'
            }
          >
            {formRender()}
          </div>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {buttonRender('')}
          </div>
        </div>
      ) : (
        <Modal
          open={showTasksModal}
          // onClose={() => closeTaskFormModal()}
          style={SmartTrackerReports ? { width: '1123px' } : commonStore.NFAIReportCustomer ? { width: '100%' } : {}}
        >
          <Modal.Header>{headerRender()}</Modal.Header>
          <Modal.Content
            style={{
              maxHeight: '70vh',
              minHeight: '400px',
              overflowY: 'auto',
              padding: '0px',
              scrollBehavior:'auto'
            }}
            className={
              SmartTrackerReports
                ? ''
                : (selectedSubTask.isCurrentSubtask &&
                      selectedSubTask.isFinish) ||
                    ((selectedSubTask.subTaskstatus === 1 ||
                      selectedSubTask.subTaskstatus === 8 ||
                      selectedSubTask.subTaskstatus === 4) &&
                      actionerName === user?.displayName)
                  ? ''
                  : 'ele-disable'
            }
          >
            {formRender()}
          </Modal.Content>
          <Modal.Actions>{buttonRender('')}</Modal.Actions>
        </Modal>
      )}
    </>
  );
}

export default observer(TaskFormModal);